import * as qa from "vue";
import { defineComponent as G, computed as L, openBlock as I, createElementBlock as U, normalizeClass as Rt, renderSlot as Y, createElementVNode as F, createCommentVNode as ke, inject as Pe, provide as De, createTextVNode as Mi, toDisplayString as Jt, watchEffect as Ce, ref as M, cloneVNode as al, h as ee, Fragment as Tt, onMounted as ge, onUnmounted as Be, watch as er, shallowRef as ji, unref as at, getCurrentInstance as il, Teleport as Ui, reactive as sl, nextTick as ll, createBlock as Aa, withCtx as bt, createVNode as Wt, onBeforeUnmount as ul, Transition as cl, renderList as _n, markRaw as Va } from "vue";
const fl = ["disabled"], dl = /* @__PURE__ */ G({
  __name: "TEButton",
  props: {
    primary: { type: Boolean },
    disabled: { type: Boolean },
    color: {}
  },
  setup(e) {
    const t = e, r = {
      zinc: "bg-zinc-500 dark:bg-zinc-800 hover:bg-zinc-600 focus:bg-zinc-600 hover:bg-zinc-600 focus:bg-zinc-600 active:bg-zinc-700 hover:dark:bg-zinc-700",
      red: "bg-red-500 dark:bg-red-800 hover:bg-red-600 focus:bg-red-600 hover:bg-red-600 focus:bg-red-600 active:bg-red-700 hover:dark:bg-red-700",
      orange: "bg-orange-500 dark:bg-orange-800 hover:bg-orange-600 focus:bg-orange-600 hover:bg-orange-600 focus:bg-orange-600 active:bg-orange-700 hover:dark:bg-orange-700",
      yellow: "bg-yellow-500 dark:bg-yellow-800 hover:bg-yellow-600 focus:bg-yellow-600 hover:bg-yellow-600 focus:bg-yellow-600 active:bg-yellow-700 hover:dark:bg-yellow-700",
      green: "bg-green-500 dark:bg-green-800 hover:bg-green-600 focus:bg-green-600 hover:bg-green-600 focus:bg-green-600 active:bg-green-700 hover:dark:bg-green-700",
      teal: "bg-teal-500 dark:bg-teal-800 hover:bg-teal-600 focus:bg-teal-600 hover:bg-teal-600 focus:bg-teal-600 active:bg-teal-700 hover:dark:bg-teal-700",
      blue: "bg-blue-500 dark:bg-blue-800 hover:bg-blue-600 focus:bg-blue-600 hover:bg-blue-600 focus:bg-blue-600 active:bg-blue-700 hover:dark:bg-blue-700",
      sky: "bg-sky-500 dark:bg-sky-800 hover:bg-sky-600 focus:bg-sky-600 hover:bg-sky-600 focus:bg-sky-600 active:bg-sky-700 hover:dark:bg-sky-700",
      indigo: "bg-indigo-500 dark:bg-indigo-800 hover:bg-indigo-600 focus:bg-indigo-600 hover:bg-indigo-600 focus:bg-indigo-600 active:bg-indigo-700 hover:dark:bg-indigo-700",
      purple: "bg-purple-500 dark:bg-purple-800 hover:bg-purple-600 focus:bg-purple-600 hover:bg-purple-600 focus:bg-purple-600 active:bg-purple-700 hover:dark:bg-purple-700",
      pink: "bg-pink-500 dark:bg-pink-800 hover:bg-pink-600 focus:bg-pink-600 hover:bg-pink-600 focus:bg-pink-600 active:bg-pink-700 hover:dark:bg-pink-700",
      primary: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700",
      accent: "bg-accent-500 dark:bg-accent-800 hover:bg-accent-600 focus:bg-accent-600 hover:bg-accent-600 focus:bg-accent-600 active:bg-accent-700 hover:dark:bg-accent-700",
      rose: "bg-rose-500 dark:bg-rose-800 hover:bg-rose-600 focus:bg-rose-600 hover:bg-rose-600 focus:bg-rose-600 active:bg-rose-700 hover:dark:bg-rose-700",
      emerald: "bg-emerald-500 dark:bg-emerald-800 hover:bg-emerald-600 focus:bg-emerald-600 hover:bg-emerald-600 focus:bg-emerald-600 active:bg-emerald-700 hover:dark:bg-emerald-700"
    }, n = L(() => r[t.color ?? "primary"]);
    return (o, i) => (I(), U("button", {
      type: "button",
      disabled: t.disabled,
      class: Rt([t.disabled ? "cursor-not-allowed bg-gray-500" : n.value, "inline-block rounded-md px-6 py-2 text-sm font-semibold leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"])
    }, [
      Y(o.$slots, "default")
    ], 10, fl));
  }
}), Dr = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, pl = {}, hl = { class: "flex w-full justify-center" }, yl = { class: "max-w-8xl w-full rounded bg-white p-4 shadow dark:border-primary-400 dark:bg-zinc-800" }, ml = {
  key: 0,
  class: "-mx-4 -mb-4 mt-5 border-t-2 bg-gray-50 px-4 pb-4 dark:border-zinc-700 dark:bg-zinc-900"
}, gl = { class: "flex justify-end pt-4" };
function vl(e, t) {
  return I(), U("div", hl, [
    F("div", yl, [
      Y(e.$slots, "default"),
      e.$slots.actions ? (I(), U("div", ml, [
        F("div", gl, [
          Y(e.$slots, "actions")
        ])
      ])) : ke("", !0)
    ])
  ]);
}
const bl = /* @__PURE__ */ Dr(pl, [["render", vl]]), wl = ["id", "value", "type", "placeholder", "autofocus", "autocomplete"], Sl = /* @__PURE__ */ G({
  __name: "TETextInput",
  props: {
    name: {},
    placeholder: {},
    required: { type: Boolean },
    type: {},
    modelValue: {},
    error: { type: Boolean },
    autocomplete: {},
    autofocus: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    function o(l) {
      const c = l.target;
      n("update:modelValue", c.value);
    }
    const i = L(() => Pe(`error-${r.name}`)), s = L(() => {
      var l;
      return (l = i.value) != null && l.value ? "border-red-500" : "border-gray-400";
    });
    return (l, c) => (I(), U("input", {
      id: l.name,
      value: l.modelValue,
      type: l.type ?? "text",
      placeholder: l.placeholder,
      class: Rt(["block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 outline-0 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-0 focus:ring-2 focus:ring-inset focus:ring-primary-600 focus:transition-all sm:text-sm sm:leading-6 dark:bg-zinc-600 dark:text-white dark:ring-zinc-900 focus:dark:ring-primary-900", s.value]),
      autofocus: l.autofocus,
      autocomplete: l.autocomplete,
      onInput: o
    }, null, 42, wl));
  }
}), El = { class: "py-2" }, _l = ["for"], Tl = {
  key: 0,
  class: "text-red-500"
}, Ol = { class: "" }, Al = {
  key: 0,
  class: "text-sm text-red-600"
}, xl = /* @__PURE__ */ G({
  __name: "TETopLabelLayout",
  props: {
    title: {},
    required: { type: Boolean },
    name: {},
    error: {}
  },
  setup(e) {
    const t = e, r = L(() => t.error ?? void 0);
    return De(
      `error-${t.name}`,
      L(() => r.value ?? void 0)
    ), (n, o) => (I(), U("div", El, [
      F("label", {
        for: n.name,
        class: "block text-sm font-medium leading-6 text-gray-900 dark:text-gray-300"
      }, [
        Mi(Jt(n.title), 1),
        n.required ? (I(), U("span", Tl, "*")) : ke("", !0)
      ], 8, _l),
      F("div", Ol, [
        Y(n.$slots, "default", { class: "block w-full" })
      ]),
      r.value ? (I(), U("div", Al, Jt(r.value), 1)) : ke("", !0)
    ]));
  }
}), Pl = /* @__PURE__ */ G({
  __name: "TEBadge",
  props: {
    type: {}
  },
  setup(e) {
    const t = e, r = {
      white: "bg-zinc-200/40 text-zinc-800 border-zinc-300 dark:border-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-200",
      accent: "bg-accent-200/40 text-accent-800 border-accent-300 dark:border-accent-700 dark:bg-accent-700/50 dark:text-accent-200",
      red: "bg-red-200/40 text-red-800 border-red-300 dark:border-red-700 dark:bg-red-900/50 dark:border-red-900 dark:text-red-500",
      orange: "bg-orange-200/40 text-orange-800 border-orange-300 dark:border-orange-700 dark:bg-orange-900/50 dark:text-orange-500",
      yellow: "bg-yellow-200/40 text-yellow-800 border-yellow-300 dark:border-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-500",
      green: "bg-green-200/40 text-green-800 border-green-300 dark:border-green-700 dark:bg-green-900/50 dark:text-green-500",
      teal: "bg-teal-200/40 text-teal-800 border-teal-300 dark:border-teal-700 dark:bg-teal-900/50 dark:text-teal-500",
      blue: "bg-blue-200/40 text-blue-800 border-blue-300 dark:border-blue-700 dark:bg-blue-900/50 dark:text-blue-500",
      sky: "bg-sky-200/40 text-sky-800 border-sky-300 dark:border-sky-700 dark:bg-sky-900/50 dark:text-sky-500",
      indigo: "bg-indigo-200/40 text-indigo-800 border-indigo-300 dark:border-indigo-700 dark:bg-indigo-900/60 dark:text-indigo-400",
      purple: "bg-purple-200/40 text-purple-800 border-purple-300 dark:border-purple-700 dark:bg-purple-900/60 dark:text-purple-400",
      pink: "bg-pink-200/40 text-pink-800 border-pink-300 dark:border-pink-700 dark:bg-pink-900/50 dark:text-pink-500",
      primary: "bg-primary-200/40 text-primary-800 border-primary-300 dark:border-primary-700 dark:bg-primary-900/50 dark:text-primary-500",
      rose: "bg-rose-200/40 text-rose-800 border-rose-300 dark:border-rose-700 dark:bg-rose-900/50 dark:text-rose-500",
      emerald: "bg-emerald-200/40 text-emerald-800 border-emerald-300 dark:border-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-500"
    }, n = L(() => r[t.type]);
    return (o, i) => (I(), U("span", {
      class: Rt([n.value, "rounded-full p-1 px-2"])
    }, [
      Y(o.$slots, "default")
    ], 2));
  }
});
function xa(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Br() {
  let e = [], t = { addEventListener(r, n, o, i) {
    return r.addEventListener(n, o, i), t.add(() => r.removeEventListener(n, o, i));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...r);
    });
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return xa(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, o) {
    let i = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: o }), this.add(() => {
      Object.assign(r.style, { [n]: i });
    });
  }, group(r) {
    let n = Br();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0) for (let o of e.splice(n, 1)) o();
    };
  }, dispose() {
    for (let r of e.splice(0)) r();
  } };
  return t;
}
var Wa;
let $l = Symbol("headlessui.useid"), Rl = 0;
const kt = (Wa = qa.useId) != null ? Wa : function() {
  return qa.inject($l, () => `${++Rl}`)();
};
function oe(e) {
  var t;
  if (e == null || e.value == null) return null;
  let r = (t = e.value.$el) != null ? t : e.value;
  return r instanceof Node ? r : null;
}
function Ge(e, t, ...r) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...r) : o;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, Ge), n;
}
var kl = Object.defineProperty, Cl = (e, t, r) => t in e ? kl(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ga = (e, t, r) => (Cl(e, typeof t != "symbol" ? t + "" : t, r), r);
let Fl = class {
  constructor() {
    Ga(this, "current", this.detect()), Ga(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, Mr = new Fl();
function tr(e) {
  if (Mr.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = oe(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let ea = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var st = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(st || {}), Hi = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Hi || {}), Ll = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Ll || {});
function Nl(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(ea)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var zi = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(zi || {});
function Il(e, t = 0) {
  var r;
  return e === ((r = tr(e)) == null ? void 0 : r.body) ? !1 : Ge(t, { 0() {
    return e.matches(ea);
  }, 1() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(ea)) return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var Dl = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Dl || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Ot(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let Bl = ["textarea", "input"].join(",");
function Ml(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, Bl)) != null ? r : !1;
}
function jl(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let o = t(r), i = t(n);
    if (o === null || i === null) return 0;
    let s = o.compareDocumentPosition(i);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Tn(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: o = [] } = {}) {
  var i;
  let s = (i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? i : document, l = Array.isArray(e) ? r ? jl(e) : e : Nl(e);
  o.length > 0 && l.length > 1 && (l = l.filter((h) => !o.includes(h))), n = n ?? s.activeElement;
  let c = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), f = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, l.indexOf(n)) - 1;
    if (t & 4) return Math.max(0, l.indexOf(n)) + 1;
    if (t & 8) return l.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = t & 32 ? { preventScroll: !0 } : {}, g = 0, m = l.length, S;
  do {
    if (g >= m || g + m <= 0) return 0;
    let h = f + g;
    if (t & 16) h = (h + m) % m;
    else {
      if (h < 0) return 3;
      if (h >= m) return 1;
    }
    S = l[h], S == null || S.focus(d), g += c;
  } while (S !== s.activeElement);
  return t & 6 && Ml(S) && S.select(), 2;
}
function qi() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Ul() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Hl() {
  return qi() || Ul();
}
function yn(e, t, r) {
  Mr.isServer || Ce((n) => {
    document.addEventListener(e, t, r), n(() => document.removeEventListener(e, t, r));
  });
}
function Vi(e, t, r) {
  Mr.isServer || Ce((n) => {
    window.addEventListener(e, t, r), n(() => window.removeEventListener(e, t, r));
  });
}
function zl(e, t, r = L(() => !0)) {
  function n(i, s) {
    if (!r.value || i.defaultPrevented) return;
    let l = s(i);
    if (l === null || !l.getRootNode().contains(l)) return;
    let c = function f(d) {
      return typeof d == "function" ? f(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let f of c) {
      if (f === null) continue;
      let d = f instanceof HTMLElement ? f : oe(f);
      if (d != null && d.contains(l) || i.composed && i.composedPath().includes(d)) return;
    }
    return !Il(l, zi.Loose) && l.tabIndex !== -1 && i.preventDefault(), t(i, l);
  }
  let o = M(null);
  yn("pointerdown", (i) => {
    var s, l;
    r.value && (o.value = ((l = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : l[0]) || i.target);
  }, !0), yn("mousedown", (i) => {
    var s, l;
    r.value && (o.value = ((l = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : l[0]) || i.target);
  }, !0), yn("click", (i) => {
    Hl() || o.value && (n(i, () => o.value), o.value = null);
  }, !0), yn("touchend", (i) => n(i, () => i.target instanceof HTMLElement ? i.target : null), !0), Vi("blur", (i) => n(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var $n = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))($n || {}), lt = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(lt || {});
function $e({ visible: e = !0, features: t = 0, ourProps: r, theirProps: n, ...o }) {
  var i;
  let s = Gi(n, r), l = Object.assign(o, { props: s });
  if (e || t & 2 && s.static) return Lo(l);
  if (t & 1) {
    let c = (i = s.unmount) == null || i ? 0 : 1;
    return Ge(c, { 0() {
      return null;
    }, 1() {
      return Lo({ ...o, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Lo(l);
}
function Lo({ props: e, attrs: t, slots: r, slot: n, name: o }) {
  var i, s;
  let { as: l, ...c } = Ki(e, ["unmount", "static"]), f = (i = r.default) == null ? void 0 : i.call(r, n), d = {};
  if (n) {
    let g = !1, m = [];
    for (let [S, h] of Object.entries(n)) typeof h == "boolean" && (g = !0), h === !0 && m.push(S);
    g && (d["data-headlessui-state"] = m.join(" "));
  }
  if (l === "template") {
    if (f = Wi(f ?? []), Object.keys(c).length > 0 || Object.keys(t).length > 0) {
      let [g, ...m] = f ?? [];
      if (!ql(g) || m.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(c).concat(Object.keys(t)).map((y) => y.trim()).filter((y, v, _) => _.indexOf(y) === v).sort((y, v) => y.localeCompare(v)).map((y) => `  - ${y}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((y) => `  - ${y}`).join(`
`)].join(`
`));
      let S = Gi((s = g.props) != null ? s : {}, c, d), h = al(g, S, !0);
      for (let y in S) y.startsWith("on") && (h.props || (h.props = {}), h.props[y] = S[y]);
      return h;
    }
    return Array.isArray(f) && f.length === 1 ? f[0] : f;
  }
  return ee(l, Object.assign({}, c, d), { default: () => f });
}
function Wi(e) {
  return e.flatMap((t) => t.type === Tt ? Wi(t.children) : [t]);
}
function Gi(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let o in n) o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r) Object.assign(t, { [n](o, ...i) {
    let s = r[n];
    for (let l of s) {
      if (o instanceof Event && o.defaultPrevented) return;
      l(o, ...i);
    }
  } });
  return t;
}
function Ki(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t) n in r && delete r[n];
  return r;
}
function ql(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Rn = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Rn || {});
let ta = G({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    var n;
    let { features: o, ...i } = e, s = { "aria-hidden": (o & 2) === 2 ? !0 : (n = i["aria-hidden"]) != null ? n : void 0, hidden: (o & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return $e({ ourProps: s, theirProps: i, slot: {}, attrs: r, slots: t, name: "Hidden" });
  };
} }), Ji = Symbol("Context");
var Ae = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Ae || {});
function Vl() {
  return Pa() !== null;
}
function Pa() {
  return Pe(Ji, null);
}
function Wl(e) {
  De(Ji, e);
}
var Xi = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Xi || {});
function Gl(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let wt = [];
Gl(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && wt[0] !== t.target && (wt.unshift(t.target), wt = wt.filter((r) => r != null && r.isConnected), wt.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Qi(e, t, r, n) {
  Mr.isServer || Ce((o) => {
    e = e ?? window, e.addEventListener(t, r, n), o(() => e.removeEventListener(t, r, n));
  });
}
var kr = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(kr || {});
function Kl() {
  let e = M(0);
  return Vi("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function Yi(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.value) {
    let n = oe(r);
    n instanceof HTMLElement && t.add(n);
  }
  return t;
}
var Zi = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(Zi || {});
let Or = Object.assign(G({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: M(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: n }) {
  let o = M(null);
  n({ el: o, $el: o });
  let i = L(() => tr(o)), s = M(!1);
  ge(() => s.value = !0), Be(() => s.value = !1), Xl({ ownerDocument: i }, L(() => s.value && !!(e.features & 16)));
  let l = Ql({ ownerDocument: i, container: o, initialFocus: L(() => e.initialFocus) }, L(() => s.value && !!(e.features & 2)));
  Yl({ ownerDocument: i, container: o, containers: e.containers, previousActiveElement: l }, L(() => s.value && !!(e.features & 8)));
  let c = Kl();
  function f(S) {
    let h = oe(o);
    h && ((y) => y())(() => {
      Ge(c.value, { [kr.Forwards]: () => {
        Tn(h, st.First, { skipElements: [S.relatedTarget] });
      }, [kr.Backwards]: () => {
        Tn(h, st.Last, { skipElements: [S.relatedTarget] });
      } });
    });
  }
  let d = M(!1);
  function g(S) {
    S.key === "Tab" && (d.value = !0, requestAnimationFrame(() => {
      d.value = !1;
    }));
  }
  function m(S) {
    if (!s.value) return;
    let h = Yi(e.containers);
    oe(o) instanceof HTMLElement && h.add(oe(o));
    let y = S.relatedTarget;
    y instanceof HTMLElement && y.dataset.headlessuiFocusGuard !== "true" && (es(h, y) || (d.value ? Tn(oe(o), Ge(c.value, { [kr.Forwards]: () => st.Next, [kr.Backwards]: () => st.Previous }) | st.WrapAround, { relativeTo: S.target }) : S.target instanceof HTMLElement && Ot(S.target)));
  }
  return () => {
    let S = {}, h = { ref: o, onKeydown: g, onFocusout: m }, { features: y, initialFocus: v, containers: _, ...T } = e;
    return ee(Tt, [!!(y & 4) && ee(ta, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: f, features: Rn.Focusable }), $e({ ourProps: h, theirProps: { ...t, ...T }, slot: S, attrs: t, slots: r, name: "FocusTrap" }), !!(y & 4) && ee(ta, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: f, features: Rn.Focusable })]);
  };
} }), { features: Zi });
function Jl(e) {
  let t = M(wt.slice());
  return er([e], ([r], [n]) => {
    n === !0 && r === !1 ? xa(() => {
      t.value.splice(0);
    }) : n === !1 && r === !0 && (t.value = wt.slice());
  }, { flush: "post" }), () => {
    var r;
    return (r = t.value.find((n) => n != null && n.isConnected)) != null ? r : null;
  };
}
function Xl({ ownerDocument: e }, t) {
  let r = Jl(t);
  ge(() => {
    Ce(() => {
      var n, o;
      t.value || ((n = e.value) == null ? void 0 : n.activeElement) === ((o = e.value) == null ? void 0 : o.body) && Ot(r());
    }, { flush: "post" });
  }), Be(() => {
    t.value && Ot(r());
  });
}
function Ql({ ownerDocument: e, container: t, initialFocus: r }, n) {
  let o = M(null), i = M(!1);
  return ge(() => i.value = !0), Be(() => i.value = !1), ge(() => {
    er([t, r, n], (s, l) => {
      if (s.every((f, d) => (l == null ? void 0 : l[d]) === f) || !n.value) return;
      let c = oe(t);
      c && xa(() => {
        var f, d;
        if (!i.value) return;
        let g = oe(r), m = (f = e.value) == null ? void 0 : f.activeElement;
        if (g) {
          if (g === m) {
            o.value = m;
            return;
          }
        } else if (c.contains(m)) {
          o.value = m;
          return;
        }
        g ? Ot(g) : Tn(c, st.First | st.NoScroll) === Hi.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), o.value = (d = e.value) == null ? void 0 : d.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), o;
}
function Yl({ ownerDocument: e, container: t, containers: r, previousActiveElement: n }, o) {
  var i;
  Qi((i = e.value) == null ? void 0 : i.defaultView, "focus", (s) => {
    if (!o.value) return;
    let l = Yi(r);
    oe(t) instanceof HTMLElement && l.add(oe(t));
    let c = n.value;
    if (!c) return;
    let f = s.target;
    f && f instanceof HTMLElement ? es(l, f) ? (n.value = f, Ot(f)) : (s.preventDefault(), s.stopPropagation(), Ot(c)) : Ot(n.value);
  }, !0);
}
function es(e, t) {
  for (let r of e) if (r.contains(t)) return !0;
  return !1;
}
function Zl(e) {
  let t = ji(e.getSnapshot());
  return Be(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function eu(e, t) {
  let r = e(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(o) {
    return n.add(o), () => n.delete(o);
  }, dispatch(o, ...i) {
    let s = t[o].call(r, ...i);
    s && (r = s, n.forEach((l) => l()));
  } };
}
function tu() {
  let e;
  return { before({ doc: t }) {
    var r;
    let n = t.documentElement;
    e = ((r = t.defaultView) != null ? r : window).innerWidth - n.clientWidth;
  }, after({ doc: t, d: r }) {
    let n = t.documentElement, o = n.clientWidth - n.offsetWidth, i = e - o;
    r.style(n, "paddingRight", `${i}px`);
  } };
}
function ru() {
  return qi() ? { before({ doc: e, d: t, meta: r }) {
    function n(o) {
      return r.containers.flatMap((i) => i()).some((i) => i.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let l = Br();
        l.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => l.dispose()));
      }
      let i = (o = window.scrollY) != null ? o : window.pageYOffset, s = null;
      t.addEventListener(e, "click", (l) => {
        if (l.target instanceof HTMLElement) try {
          let c = l.target.closest("a");
          if (!c) return;
          let { hash: f } = new URL(c.href), d = e.querySelector(f);
          d && !n(d) && (s = d);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (l) => {
        if (l.target instanceof HTMLElement) if (n(l.target)) {
          let c = l.target;
          for (; c.parentElement && n(c.parentElement); ) c = c.parentElement;
          t.style(c, "overscrollBehavior", "contain");
        } else t.style(l.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (l) => {
        if (l.target instanceof HTMLElement) {
          if (l.target.tagName === "INPUT") return;
          if (n(l.target)) {
            let c = l.target;
            for (; c.parentElement && c.dataset.headlessuiPortal !== "" && !(c.scrollHeight > c.clientHeight || c.scrollWidth > c.clientWidth); ) c = c.parentElement;
            c.dataset.headlessuiPortal === "" && l.preventDefault();
          } else l.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var l;
        let c = (l = window.scrollY) != null ? l : window.pageYOffset;
        i !== c && window.scrollTo(0, i), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function nu() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function ou(e) {
  let t = {};
  for (let r of e) Object.assign(t, r(t));
  return t;
}
let Et = eu(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let n = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: Br(), meta: /* @__PURE__ */ new Set() };
  return n.count++, n.meta.add(t), this.set(e, n), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let n = { doc: e, d: t, meta: ou(r) }, o = [ru(), tu(), nu()];
  o.forEach(({ before: i }) => i == null ? void 0 : i(n)), o.forEach(({ after: i }) => i == null ? void 0 : i(n));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Et.subscribe(() => {
  let e = Et.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e) t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let n = t.get(r.doc) === "hidden", o = r.count !== 0;
    (o && !n || !o && n) && Et.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && Et.dispatch("TEARDOWN", r);
  }
});
function au(e, t, r) {
  let n = Zl(Et), o = L(() => {
    let i = e.value ? n.value.get(e.value) : void 0;
    return i ? i.count > 0 : !1;
  });
  return er([e, t], ([i, s], [l], c) => {
    if (!i || !s) return;
    Et.dispatch("PUSH", i, r);
    let f = !1;
    c(() => {
      f || (Et.dispatch("POP", l ?? i, r), f = !0);
    });
  }, { immediate: !0 }), o;
}
let No = /* @__PURE__ */ new Map(), Ar = /* @__PURE__ */ new Map();
function Ka(e, t = M(!0)) {
  Ce((r) => {
    var n;
    if (!t.value) return;
    let o = oe(e);
    if (!o) return;
    r(function() {
      var s;
      if (!o) return;
      let l = (s = Ar.get(o)) != null ? s : 1;
      if (l === 1 ? Ar.delete(o) : Ar.set(o, l - 1), l !== 1) return;
      let c = No.get(o);
      c && (c["aria-hidden"] === null ? o.removeAttribute("aria-hidden") : o.setAttribute("aria-hidden", c["aria-hidden"]), o.inert = c.inert, No.delete(o));
    });
    let i = (n = Ar.get(o)) != null ? n : 0;
    Ar.set(o, i + 1), i === 0 && (No.set(o, { "aria-hidden": o.getAttribute("aria-hidden"), inert: o.inert }), o.setAttribute("aria-hidden", "true"), o.inert = !0);
  });
}
function iu({ defaultContainers: e = [], portals: t, mainTreeNodeRef: r } = {}) {
  let n = M(null), o = tr(n);
  function i() {
    var s, l, c;
    let f = [];
    for (let d of e) d !== null && (d instanceof HTMLElement ? f.push(d) : "value" in d && d.value instanceof HTMLElement && f.push(d.value));
    if (t != null && t.value) for (let d of t.value) f.push(d);
    for (let d of (s = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? s : []) d !== document.body && d !== document.head && d instanceof HTMLElement && d.id !== "headlessui-portal-root" && (d.contains(oe(n)) || d.contains((c = (l = oe(n)) == null ? void 0 : l.getRootNode()) == null ? void 0 : c.host) || f.some((g) => d.contains(g)) || f.push(d));
    return f;
  }
  return { resolveContainers: i, contains(s) {
    return i().some((l) => l.contains(s));
  }, mainTreeNodeRef: n, MainTreeNode() {
    return r != null ? null : ee(ta, { features: Rn.Hidden, ref: n });
  } };
}
let ts = Symbol("ForcePortalRootContext");
function su() {
  return Pe(ts, !1);
}
let ra = G({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: r }) {
  return De(ts, e.force), () => {
    let { force: n, ...o } = e;
    return $e({ theirProps: o, ourProps: {}, slot: {}, slots: t, attrs: r, name: "ForcePortalRoot" });
  };
} }), rs = Symbol("StackContext");
var na = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(na || {});
function lu() {
  return Pe(rs, () => {
  });
}
function uu({ type: e, enabled: t, element: r, onUpdate: n }) {
  let o = lu();
  function i(...s) {
    n == null || n(...s), o(...s);
  }
  ge(() => {
    er(t, (s, l) => {
      s ? i(0, e, r) : l === !0 && i(1, e, r);
    }, { immediate: !0, flush: "sync" });
  }), Be(() => {
    t.value && i(1, e, r);
  }), De(rs, i);
}
let ns = Symbol("DescriptionContext");
function cu() {
  let e = Pe(ns, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function fu({ slot: e = M({}), name: t = "Description", props: r = {} } = {}) {
  let n = M([]);
  function o(i) {
    return n.value.push(i), () => {
      let s = n.value.indexOf(i);
      s !== -1 && n.value.splice(s, 1);
    };
  }
  return De(ns, { register: o, slot: e, name: t, props: r }), L(() => n.value.length > 0 ? n.value.join(" ") : void 0);
}
G({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-description-${kt()}`, i = cu();
  return ge(() => Be(i.register(o))), () => {
    let { name: s = "Description", slot: l = M({}), props: c = {} } = i, { ...f } = e, d = { ...Object.entries(c).reduce((g, [m, S]) => Object.assign(g, { [m]: at(S) }), {}), id: o };
    return $e({ ourProps: d, theirProps: f, slot: l.value, attrs: t, slots: r, name: s });
  };
} });
function du(e) {
  let t = tr(e);
  if (!t) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let r = t.getElementById("headlessui-portal-root");
  if (r) return r;
  let n = t.createElement("div");
  return n.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(n);
}
const oa = /* @__PURE__ */ new WeakMap();
function pu(e) {
  var t;
  return (t = oa.get(e)) != null ? t : 0;
}
function Ja(e, t) {
  let r = t(pu(e));
  return r <= 0 ? oa.delete(e) : oa.set(e, r), r;
}
let os = G({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: r }) {
  let n = M(null), o = L(() => tr(n)), i = su(), s = Pe(as, null), l = M(i === !0 || s == null ? du(n.value) : s.resolveTarget());
  l.value && Ja(l.value, (m) => m + 1);
  let c = M(!1);
  ge(() => {
    c.value = !0;
  }), Ce(() => {
    i || s != null && (l.value = s.resolveTarget());
  });
  let f = Pe(aa, null), d = !1, g = il();
  return er(n, () => {
    if (d || !f) return;
    let m = oe(n);
    m && (Be(f.register(m), g), d = !0);
  }), Be(() => {
    var m, S;
    let h = (m = o.value) == null ? void 0 : m.getElementById("headlessui-portal-root");
    !h || l.value !== h || Ja(l.value, (y) => y - 1) || l.value.children.length > 0 || (S = l.value.parentElement) == null || S.removeChild(l.value);
  }), () => {
    if (!c.value || l.value === null) return null;
    let m = { ref: n, "data-headlessui-portal": "" };
    return ee(Ui, { to: l.value }, $e({ ourProps: m, theirProps: e, slot: {}, attrs: r, slots: t, name: "Portal" }));
  };
} }), aa = Symbol("PortalParentContext");
function hu() {
  let e = Pe(aa, null), t = M([]);
  function r(i) {
    return t.value.push(i), e && e.register(i), () => n(i);
  }
  function n(i) {
    let s = t.value.indexOf(i);
    s !== -1 && t.value.splice(s, 1), e && e.unregister(i);
  }
  let o = { register: r, unregister: n, portals: t };
  return [t, G({ name: "PortalWrapper", setup(i, { slots: s }) {
    return De(aa, o), () => {
      var l;
      return (l = s.default) == null ? void 0 : l.call(s);
    };
  } })];
}
let as = Symbol("PortalGroupContext"), yu = G({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: r }) {
  let n = sl({ resolveTarget() {
    return e.target;
  } });
  return De(as, n), () => {
    let { target: o, ...i } = e;
    return $e({ theirProps: i, ourProps: {}, slot: {}, attrs: t, slots: r, name: "PortalGroup" });
  };
} });
var mu = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(mu || {});
let ia = Symbol("DialogContext");
function jr(e) {
  let t = Pe(ia, null);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, jr), r;
  }
  return t;
}
let mn = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", gu = G({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: mn }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: r, slots: n, expose: o }) {
  var i, s;
  let l = (i = e.id) != null ? i : `headlessui-dialog-${kt()}`, c = M(!1);
  ge(() => {
    c.value = !0;
  });
  let f = !1, d = L(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (f || (f = !0, console.warn(`Invalid role [${d}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), g = M(0), m = Pa(), S = L(() => e.open === mn && m !== null ? (m.value & Ae.Open) === Ae.Open : e.open), h = M(null), y = L(() => tr(h));
  if (o({ el: h, $el: h }), !(e.open !== mn || m !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof S.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${S.value === mn ? void 0 : e.open}`);
  let v = L(() => c.value && S.value ? 0 : 1), _ = L(() => v.value === 0), T = L(() => g.value > 1), E = Pe(ia, null) !== null, [O, P] = hu(), { resolveContainers: $, mainTreeNodeRef: D, MainTreeNode: A } = iu({ portals: O, defaultContainers: [L(() => {
    var q;
    return (q = we.panelRef.value) != null ? q : h.value;
  })] }), k = L(() => T.value ? "parent" : "leaf"), W = L(() => m !== null ? (m.value & Ae.Closing) === Ae.Closing : !1), ae = L(() => E || W.value ? !1 : _.value), te = L(() => {
    var q, J, X;
    return (X = Array.from((J = (q = y.value) == null ? void 0 : q.querySelectorAll("body > *")) != null ? J : []).find((fe) => fe.id === "headlessui-portal-root" ? !1 : fe.contains(oe(D)) && fe instanceof HTMLElement)) != null ? X : null;
  });
  Ka(te, ae);
  let K = L(() => T.value ? !0 : _.value), ie = L(() => {
    var q, J, X;
    return (X = Array.from((J = (q = y.value) == null ? void 0 : q.querySelectorAll("[data-headlessui-portal]")) != null ? J : []).find((fe) => fe.contains(oe(D)) && fe instanceof HTMLElement)) != null ? X : null;
  });
  Ka(ie, K), uu({ type: "Dialog", enabled: L(() => v.value === 0), element: h, onUpdate: (q, J) => {
    if (J === "Dialog") return Ge(q, { [na.Add]: () => g.value += 1, [na.Remove]: () => g.value -= 1 });
  } });
  let Q = fu({ name: "DialogDescription", slot: L(() => ({ open: S.value })) }), se = M(null), we = { titleId: se, panelRef: M(null), dialogState: v, setTitleId(q) {
    se.value !== q && (se.value = q);
  }, close() {
    t("close", !1);
  } };
  De(ia, we);
  let tt = L(() => !(!_.value || T.value));
  zl($, (q, J) => {
    q.preventDefault(), we.close(), ll(() => J == null ? void 0 : J.focus());
  }, tt);
  let Ke = L(() => !(T.value || v.value !== 0));
  Qi((s = y.value) == null ? void 0 : s.defaultView, "keydown", (q) => {
    Ke.value && (q.defaultPrevented || q.key === Xi.Escape && (q.preventDefault(), q.stopPropagation(), we.close()));
  });
  let B = L(() => !(W.value || v.value !== 0 || E));
  return au(y, B, (q) => {
    var J;
    return { containers: [...(J = q.containers) != null ? J : [], $] };
  }), Ce((q) => {
    if (v.value !== 0) return;
    let J = oe(h);
    if (!J) return;
    let X = new ResizeObserver((fe) => {
      for (let H of fe) {
        let Je = H.target.getBoundingClientRect();
        Je.x === 0 && Je.y === 0 && Je.width === 0 && Je.height === 0 && we.close();
      }
    });
    X.observe(J), q(() => X.disconnect());
  }), () => {
    let { open: q, initialFocus: J, ...X } = e, fe = { ...r, ref: h, id: l, role: d.value, "aria-modal": v.value === 0 ? !0 : void 0, "aria-labelledby": se.value, "aria-describedby": Q.value }, H = { open: v.value === 0 };
    return ee(ra, { force: !0 }, () => [ee(os, () => ee(yu, { target: h.value }, () => ee(ra, { force: !1 }, () => ee(Or, { initialFocus: J, containers: $, features: _.value ? Ge(k.value, { parent: Or.features.RestoreFocus, leaf: Or.features.All & ~Or.features.FocusLock }) : Or.features.None }, () => ee(P, {}, () => $e({ ourProps: fe, theirProps: { ...X, ...r }, slot: H, attrs: r, slots: n, visible: v.value === 0, features: $n.RenderStrategy | $n.Static, name: "Dialog" })))))), ee(A)]);
  };
} });
G({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-dialog-overlay-${kt()}`, i = jr("DialogOverlay");
  function s(l) {
    l.target === l.currentTarget && (l.preventDefault(), l.stopPropagation(), i.close());
  }
  return () => {
    let { ...l } = e;
    return $e({ ourProps: { id: o, "aria-hidden": !0, onClick: s }, theirProps: l, slot: { open: i.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogOverlay" });
  };
} });
G({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: r, expose: n }) {
  var o;
  let i = (o = e.id) != null ? o : `headlessui-dialog-backdrop-${kt()}`, s = jr("DialogBackdrop"), l = M(null);
  return n({ el: l, $el: l }), ge(() => {
    if (s.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...c } = e, f = { id: i, ref: l, "aria-hidden": !0 };
    return ee(ra, { force: !0 }, () => ee(os, () => $e({ ourProps: f, theirProps: { ...t, ...c }, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogBackdrop" })));
  };
} });
let vu = G({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r, expose: n }) {
  var o;
  let i = (o = e.id) != null ? o : `headlessui-dialog-panel-${kt()}`, s = jr("DialogPanel");
  n({ el: s.panelRef, $el: s.panelRef });
  function l(c) {
    c.stopPropagation();
  }
  return () => {
    let { ...c } = e, f = { id: i, ref: s.panelRef, onClick: l };
    return $e({ ourProps: f, theirProps: c, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogPanel" });
  };
} }), bu = G({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: r }) {
  var n;
  let o = (n = e.id) != null ? n : `headlessui-dialog-title-${kt()}`, i = jr("DialogTitle");
  return ge(() => {
    i.setTitleId(o), Be(() => i.setTitleId(null));
  }), () => {
    let { ...s } = e;
    return $e({ ourProps: { id: o }, theirProps: s, slot: { open: i.dialogState.value === 0 }, attrs: t, slots: r, name: "DialogTitle" });
  };
} });
function wu(e) {
  let t = { called: !1 };
  return (...r) => {
    if (!t.called) return t.called = !0, e(...r);
  };
}
function Io(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function gn(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var sa = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(sa || {});
function Su(e, t) {
  let r = Br();
  if (!e) return r.dispose;
  let { transitionDuration: n, transitionDelay: o } = getComputedStyle(e), [i, s] = [n, o].map((l) => {
    let [c = 0] = l.split(",").filter(Boolean).map((f) => f.includes("ms") ? parseFloat(f) : parseFloat(f) * 1e3).sort((f, d) => d - f);
    return c;
  });
  return i !== 0 ? r.setTimeout(() => t("finished"), i + s) : t("finished"), r.add(() => t("cancelled")), r.dispose;
}
function Xa(e, t, r, n, o, i) {
  let s = Br(), l = i !== void 0 ? wu(i) : () => {
  };
  return gn(e, ...o), Io(e, ...t, ...r), s.nextFrame(() => {
    gn(e, ...r), Io(e, ...n), s.add(Su(e, (c) => (gn(e, ...n, ...t), Io(e, ...o), l(c))));
  }), s.add(() => gn(e, ...t, ...r, ...n, ...o)), s.add(() => l("cancelled")), s.dispose;
}
function vt(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let $a = Symbol("TransitionContext");
var Eu = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(Eu || {});
function _u() {
  return Pe($a, null) !== null;
}
function Tu() {
  let e = Pe($a, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function Ou() {
  let e = Pe(Ra, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Ra = Symbol("NestingContext");
function Mn(e) {
  return "children" in e ? Mn(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function is(e) {
  let t = M([]), r = M(!1);
  ge(() => r.value = !0), Be(() => r.value = !1);
  function n(i, s = lt.Hidden) {
    let l = t.value.findIndex(({ id: c }) => c === i);
    l !== -1 && (Ge(s, { [lt.Unmount]() {
      t.value.splice(l, 1);
    }, [lt.Hidden]() {
      t.value[l].state = "hidden";
    } }), !Mn(t) && r.value && (e == null || e()));
  }
  function o(i) {
    let s = t.value.find(({ id: l }) => l === i);
    return s ? s.state !== "visible" && (s.state = "visible") : t.value.push({ id: i, state: "visible" }), () => n(i, lt.Unmount);
  }
  return { children: t, register: o, unregister: n };
}
let ss = $n.RenderStrategy, la = G({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: n, expose: o }) {
  let i = M(0);
  function s() {
    i.value |= Ae.Opening, t("beforeEnter");
  }
  function l() {
    i.value &= ~Ae.Opening, t("afterEnter");
  }
  function c() {
    i.value |= Ae.Closing, t("beforeLeave");
  }
  function f() {
    i.value &= ~Ae.Closing, t("afterLeave");
  }
  if (!_u() && Vl()) return () => ee(ls, { ...e, onBeforeEnter: s, onAfterEnter: l, onBeforeLeave: c, onAfterLeave: f }, n);
  let d = M(null), g = L(() => e.unmount ? lt.Unmount : lt.Hidden);
  o({ el: d, $el: d });
  let { show: m, appear: S } = Tu(), { register: h, unregister: y } = Ou(), v = M(m.value ? "visible" : "hidden"), _ = { value: !0 }, T = kt(), E = { value: !1 }, O = is(() => {
    !E.value && v.value !== "hidden" && (v.value = "hidden", y(T), f());
  });
  ge(() => {
    let K = h(T);
    Be(K);
  }), Ce(() => {
    if (g.value === lt.Hidden && T) {
      if (m.value && v.value !== "visible") {
        v.value = "visible";
        return;
      }
      Ge(v.value, { hidden: () => y(T), visible: () => h(T) });
    }
  });
  let P = vt(e.enter), $ = vt(e.enterFrom), D = vt(e.enterTo), A = vt(e.entered), k = vt(e.leave), W = vt(e.leaveFrom), ae = vt(e.leaveTo);
  ge(() => {
    Ce(() => {
      if (v.value === "visible") {
        let K = oe(d);
        if (K instanceof Comment && K.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function te(K) {
    let ie = _.value && !S.value, Q = oe(d);
    !Q || !(Q instanceof HTMLElement) || ie || (E.value = !0, m.value && s(), m.value || c(), K(m.value ? Xa(Q, P, $, D, A, (se) => {
      E.value = !1, se === sa.Finished && l();
    }) : Xa(Q, k, W, ae, A, (se) => {
      E.value = !1, se === sa.Finished && (Mn(O) || (v.value = "hidden", y(T), f()));
    })));
  }
  return ge(() => {
    er([m], (K, ie, Q) => {
      te(Q), _.value = !1;
    }, { immediate: !0 });
  }), De(Ra, O), Wl(L(() => Ge(v.value, { visible: Ae.Open, hidden: Ae.Closed }) | i.value)), () => {
    let { appear: K, show: ie, enter: Q, enterFrom: se, enterTo: we, entered: tt, leave: Ke, leaveFrom: B, leaveTo: q, ...J } = e, X = { ref: d }, fe = { ...J, ...S.value && m.value && Mr.isServer ? { class: Rt([r.class, J.class, ...P, ...$]) } : {} };
    return $e({ theirProps: fe, ourProps: X, slot: {}, slots: n, attrs: r, features: ss, visible: v.value === "visible", name: "TransitionChild" });
  };
} }), Au = la, ls = G({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: r, slots: n }) {
  let o = Pa(), i = L(() => e.show === null && o !== null ? (o.value & Ae.Open) === Ae.Open : e.show);
  Ce(() => {
    if (![!0, !1].includes(i.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let s = M(i.value ? "visible" : "hidden"), l = is(() => {
    s.value = "hidden";
  }), c = M(!0), f = { show: i, appear: L(() => e.appear || !c.value) };
  return ge(() => {
    Ce(() => {
      c.value = !1, i.value ? s.value = "visible" : Mn(l) || (s.value = "hidden");
    });
  }), De(Ra, l), De($a, f), () => {
    let d = Ki(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), g = { unmount: e.unmount };
    return $e({ ourProps: { ...g, as: "template" }, theirProps: {}, slot: {}, slots: { ...n, default: () => [ee(Au, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...r, ...g, ...d }, n.default)] }, attrs: {}, features: ss, visible: s.value === "visible", name: "Transition" });
  };
} });
const xu = { class: "fixed inset-0 z-10 overflow-y-auto" }, Pu = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }, $u = { class: "bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 dark:bg-zinc-800" }, Ru = { class: "sm:flex sm:items-start" }, ku = { class: "mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" }, Cu = { class: "mt-2" }, Fu = { class: "text-sm text-gray-500 dark:text-zinc-200" }, Lu = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 dark:bg-zinc-700" }, Nu = /* @__PURE__ */ G({
  __name: "TEModal",
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(e) {
    return (t, r) => (I(), Aa(at(ls), {
      as: "template",
      show: t.open
    }, {
      default: bt(() => [
        Wt(at(gu), {
          as: "div",
          class: "relative z-10",
          onClose: r[0] || (r[0] = (n) => t.$emit("update:open", !1))
        }, {
          default: bt(() => [
            Wt(at(la), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: bt(() => r[1] || (r[1] = [
                F("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
              ])),
              _: 1
            }),
            F("div", xu, [
              F("div", Pu, [
                Wt(at(la), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: bt(() => [
                    Wt(at(vu), { class: "relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg dark:bg-zinc-800" }, {
                      default: bt(() => [
                        F("div", $u, [
                          F("div", Ru, [
                            F("div", ku, [
                              Wt(at(bu), {
                                as: "h3",
                                class: "text-base font-semibold leading-6 text-gray-900 dark:text-zinc-50"
                              }, {
                                default: bt(() => [
                                  Y(t.$slots, "title")
                                ]),
                                _: 3
                              }),
                              F("div", Cu, [
                                F("p", Fu, [
                                  Y(t.$slots, "default")
                                ])
                              ])
                            ])
                          ])
                        ]),
                        F("div", Lu, [
                          Y(t.$slots, "actions")
                        ])
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Iu = {}, Du = {
  "aria-label": "assertive",
  class: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
};
function Bu(e, t) {
  return I(), U("div", Du, t[0] || (t[0] = [
    F("div", {
      id: "te-notifications",
      class: "flex w-full flex-col items-center space-y-4 sm:items-end"
    }, null, -1)
  ]));
}
const Mu = /* @__PURE__ */ Dr(Iu, [["render", Bu]]), ju = {
  key: 0,
  class: "dark:bg-zinc-800 pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 dark:ring-zinc-700"
}, Uu = { class: "p-4" }, Hu = { class: "flex items-start" }, zu = {
  key: 0,
  class: "mr-3 shrink-0"
}, qu = { class: "w-0 flex-1" }, Vu = { class: "text-sm font-medium text-zinc-900 dark:text-white" }, Wu = {
  key: 0,
  class: "mt-1 text-sm text-zinc-500 dark:text-zinc-100"
}, Gu = {
  key: 1,
  class: "mt-3 flex space-x-7"
}, Ku = {
  key: 1,
  class: "ml-4 flex shrink-0"
}, ua = /* @__PURE__ */ G({
  __name: "TENotification",
  props: {
    show: { type: Boolean },
    closeable: { type: Boolean },
    title: {},
    description: {},
    autoClose: { type: Boolean },
    color: {}
  },
  emits: ["update:show"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = M(!1);
    let i;
    return ge(() => {
      o.value = !0, ul(() => {
        clearTimeout(i);
      });
    }), setTimeout(() => {
      n("update:show", !1);
    }, 2500), Ce(() => {
      r.autoClose && r.show ? typeof window < "u" && (i = window.setTimeout(() => {
        n("update:show", !1);
      }, 2500)) : i && clearTimeout(i);
    }), (s, l) => o.value ? (I(), Aa(Ui, {
      key: 0,
      to: "#te-notifications"
    }, [
      Wt(cl, {
        "enter-active-class": "transition duration-300 ease-out transform",
        "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
        "leave-active-class": "transition duration-100 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }),
      s.show ? (I(), U("div", ju, [
        s.autoClose ? (I(), U("div", {
          key: 0,
          class: Rt(["te-notification-progress h-1", {
            "bg-green-500": s.color === "green",
            "bg-red-500": s.color === "red",
            "bg-primary-500": !s.color
          }]),
          style: { "animation-duration": "2500ms" }
        }, null, 2)) : ke("", !0),
        F("div", Uu, [
          F("div", Hu, [
            s.$slots.icon ? (I(), U("div", zu, [
              Y(s.$slots, "icon")
            ])) : ke("", !0),
            F("div", qu, [
              F("p", Vu, Jt(s.title), 1),
              s.description || s.$slots.default ? (I(), U("p", Wu, [
                Y(s.$slots, "default", {}, () => [
                  Mi(Jt(s.description), 1)
                ])
              ])) : ke("", !0),
              s.$slots.actions ? (I(), U("div", Gu, [
                Y(s.$slots, "actions")
              ])) : ke("", !0)
            ]),
            s.closeable ? (I(), U("div", Ku, [
              F("button", {
                class: "size-4",
                type: "submit",
                onClick: l[0] || (l[0] = (c) => s.$emit("update:show", !1))
              }, l[1] || (l[1] = [
                F("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5",
                  class: "dark:text-white size-6",
                  stroke: "currentColor"
                }, [
                  F("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "M6 18 18 6M6 6l12 12"
                  })
                ], -1)
              ]))
            ])) : ke("", !0)
          ])
        ])
      ])) : ke("", !0)
    ])) : ke("", !0);
  }
}), Ju = G({
  name: "TEFlashNotification",
  components: { TENotification: ua },
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: void 0
    },
    autoClose: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:show"],
  // eslint-disable-next-line vue/component-api-style
  render() {
    return ee(ua, {
      show: this.show,
      "onUpdate:show": (e) => this.$emit("update:show", e),
      title: this.title,
      description: this.description,
      autoClose: !0
    });
  }
}), Xu = {}, Qu = { class: "max-w-8xl bg-white w-full rounded-md shadow-xl dark:bg-zinc-800" }, Yu = { class: "p-4 dark:border-zinc-700 border-b-2" }, Zu = { class: "text-2xl font-medium dark:text-gray-50" }, ec = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-gray-300"
};
function tc(e, t) {
  return I(), U("div", Qu, [
    F("div", Yu, [
      F("h2", Zu, [
        Y(e.$slots, "title")
      ]),
      e.$slots.subtitle ? (I(), U("p", ec, [
        Y(e.$slots, "subtitle")
      ])) : ke("", !0)
    ]),
    F("div", null, [
      Y(e.$slots, "default")
    ])
  ]);
}
const rc = /* @__PURE__ */ Dr(Xu, [["render", tc]]), nc = {}, oc = { class: "md:grid md:grid-cols-2 hover:bg-gray-50 md:space-y-0 space-y-1 p-4 border-b dark:border-zinc-700 dark:hover:bg-zinc-700" }, ac = { class: "text-gray-600 dark:text-gray-200" }, ic = { class: "dark:text-white" };
function sc(e, t) {
  return I(), U("div", oc, [
    F("p", ac, [
      Y(e.$slots, "name")
    ]),
    F("p", ic, [
      Y(e.$slots, "default")
    ])
  ]);
}
const lc = /* @__PURE__ */ Dr(nc, [["render", sc]]), uc = ["model-value"], cc = /* @__PURE__ */ G({
  __name: "TESelect",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, r) => (I(), U("select", {
      "model-value": t.modelValue,
      class: "block w-full appearance-none rounded border border-gray-300 bg-white px-4 py-2 pr-8 leading-tight text-gray-700 focus:border-blue-500 focus:bg-white focus:outline-none dark:border-gray-500 dark:bg-zinc-800 dark:text-white dark:ring-primary-600 dark:ring-offset-gray-700 dark:focus:border-primary-600 dark:focus:bg-zinc-800 dark:focus:ring-primary-600 dark:focus:ring-offset-gray-700",
      "onUpdate:modelValue": r[0] || (r[0] = (n) => t.$emit("update:modelValue", n))
    }, [
      Y(t.$slots, "default")
    ], 8, uc));
  }
}), fc = {}, dc = { class: "text-base font-semibold leading-7 text-gray-900 dark:text-gray-50" }, pc = { class: "mt-1 text-sm leading-6 text-gray-600 dark:text-gray-300" };
function hc(e, t) {
  return I(), U(Tt, null, [
    F("h2", dc, [
      Y(e.$slots, "header")
    ]),
    F("p", pc, [
      Y(e.$slots, "default")
    ])
  ], 64);
}
const yc = /* @__PURE__ */ Dr(fc, [["render", hc]]), mc = { class: "flex items-center justify-between px-4 py-3 sm:px-6" }, gc = { class: "flex flex-1 justify-between sm:hidden" }, vc = ["href"], bc = ["href"], wc = { class: "hidden sm:block" }, Sc = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-sm",
  "aria-label": "Pagination"
}, Ec = ["href", "innerHTML"], _c = "first:rounded-l-md last:rounded-r-md relative z-10 inline-flex items-center dark:bg-primary-800 bg-primary-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600", Tc = "first:rounded-l-md last:rounded-r-md relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 dark:bg-zinc-800 dark:text-white dark:ring-primary-600 dark:hover:bg-primary-600 dark:focus:bg-primary-600 dark:focus:ring-primary-600 dark:focus:ring-offset-gray-700 dark:focus:outline-primary-600", Oc = /* @__PURE__ */ G({
  __name: "TEPagination",
  props: {
    pagination: {}
  },
  setup(e) {
    return (t, r) => (I(), U("div", mc, [
      F("div", gc, [
        F("a", {
          href: t.pagination.links[0].url ?? void 0,
          class: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
        }, "Vorherige Seite", 8, vc),
        F("a", {
          href: t.pagination.links[t.pagination.links.length - 1].url ?? "#",
          class: "bg-primary-500 dark:bg-primary-800 hover:bg-primary-600 focus:bg-primary-600 hover:bg-primary-600 focus:bg-primary-600 active:bg-primary-700 hover:dark:bg-primary-700 inline-block rounded-full px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out focus:outline-none focus:ring-0"
        }, "Nächste", 8, bc)
      ]),
      F("div", wc, [
        F("nav", Sc, [
          (I(!0), U(Tt, null, _n(t.pagination.links, (n) => (I(), U("a", {
            key: n.label,
            href: n.url ?? void 0,
            class: Rt(["whitespace-nowrap", n.active ? _c : Tc]),
            innerHTML: n.label
          }, null, 10, Ec))), 128))
        ])
      ])
    ]));
  }
}), Ac = { class: "overflow-x-auto sm:-mx-6 lg:-mx-8" }, xc = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }, Pc = { class: "overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg" }, $c = { class: "min-w-full divide-y divide-gray-300" }, Rc = { class: "border-b border-neutral-200 bg-zinc-50 dark:bg-zinc-800 font-medium dark:border-white/10" }, kc = { class: "divide-y divide-gray-200 bg-white" }, Cc = {
  key: 0,
  class: "relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6"
}, Fc = /* @__PURE__ */ G({
  __name: "TETable",
  props: {
    data: {},
    headers: {},
    card: { type: Boolean }
  },
  setup(e) {
    return (t, r) => (I(), U("div", Ac, [
      F("div", xc, [
        F("div", Pc, [
          F("table", $c, [
            F("thead", Rc, [
              F("tr", null, [
                (I(!0), U(Tt, null, _n(t.headers, (n) => (I(), U("th", {
                  key: n.key,
                  scope: "col",
                  class: Rt(["p-3 text-left text-sm font-semibold text-gray-900", `${n.bold ? "font-bold" : void 0}`])
                }, Jt(n.name), 3))), 128))
              ])
            ]),
            F("tbody", kc, [
              (I(!0), U(Tt, null, _n(t.data, (n, o) => (I(), U("tr", { key: o }, [
                (I(!0), U(Tt, null, _n(t.headers, (i) => (I(), U("td", {
                  key: i.key,
                  class: "whitespace-nowrap px-3 py-4 text-sm"
                }, Jt(n[i.key]), 1))), 128)),
                t.$slots.action ? (I(), U("td", Cc, [
                  Y(t.$slots, "action", { rowData: n })
                ])) : ke("", !0)
              ]))), 128))
            ])
          ])
        ])
      ])
    ]));
  }
});
function us(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Lc } = Object.prototype, { getPrototypeOf: ka } = Object, jn = /* @__PURE__ */ ((e) => (t) => {
  const r = Lc.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Me = (e) => (e = e.toLowerCase(), (t) => jn(t) === e), Un = (e) => (t) => typeof t === e, { isArray: rr } = Array, Nr = Un("undefined");
function Nc(e) {
  return e !== null && !Nr(e) && e.constructor !== null && !Nr(e.constructor) && xe(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const cs = Me("ArrayBuffer");
function Ic(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && cs(e.buffer), t;
}
const Dc = Un("string"), xe = Un("function"), fs = Un("number"), Hn = (e) => e !== null && typeof e == "object", Bc = (e) => e === !0 || e === !1, On = (e) => {
  if (jn(e) !== "object")
    return !1;
  const t = ka(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Mc = Me("Date"), jc = Me("File"), Uc = Me("Blob"), Hc = Me("FileList"), zc = (e) => Hn(e) && xe(e.pipe), qc = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || xe(e.append) && ((t = jn(e)) === "formdata" || // detect form-data instance
  t === "object" && xe(e.toString) && e.toString() === "[object FormData]"));
}, Vc = Me("URLSearchParams"), [Wc, Gc, Kc, Jc] = ["ReadableStream", "Request", "Response", "Headers"].map(Me), Xc = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ur(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), rr(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const i = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let l;
    for (n = 0; n < s; n++)
      l = i[n], t.call(null, e[l], l, e);
  }
}
function ds(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const _t = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ps = (e) => !Nr(e) && e !== _t;
function ca() {
  const { caseless: e } = ps(this) && this || {}, t = {}, r = (n, o) => {
    const i = e && ds(t, o) || o;
    On(t[i]) && On(n) ? t[i] = ca(t[i], n) : On(n) ? t[i] = ca({}, n) : rr(n) ? t[i] = n.slice() : t[i] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && Ur(arguments[n], r);
  return t;
}
const Qc = (e, t, r, { allOwnKeys: n } = {}) => (Ur(t, (o, i) => {
  r && xe(o) ? e[i] = us(o, r) : e[i] = o;
}, { allOwnKeys: n }), e), Yc = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Zc = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, ef = (e, t, r, n) => {
  let o, i, s;
  const l = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), i = o.length; i-- > 0; )
      s = o[i], (!n || n(s, e, t)) && !l[s] && (t[s] = e[s], l[s] = !0);
    e = r !== !1 && ka(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, tf = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, rf = (e) => {
  if (!e) return null;
  if (rr(e)) return e;
  let t = e.length;
  if (!fs(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, nf = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && ka(Uint8Array)), of = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const i = o.value;
    t.call(e, i[0], i[1]);
  }
}, af = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, sf = Me("HTMLFormElement"), lf = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), Qa = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), uf = Me("RegExp"), hs = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Ur(r, (o, i) => {
    let s;
    (s = t(o, i, e)) !== !1 && (n[i] = s || o);
  }), Object.defineProperties(e, n);
}, cf = (e) => {
  hs(e, (t, r) => {
    if (xe(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (xe(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, ff = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((i) => {
      r[i] = !0;
    });
  };
  return rr(e) ? n(e) : n(String(e).split(t)), r;
}, df = () => {
}, pf = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Do = "abcdefghijklmnopqrstuvwxyz", Ya = "0123456789", ys = {
  DIGIT: Ya,
  ALPHA: Do,
  ALPHA_DIGIT: Do + Do.toUpperCase() + Ya
}, hf = (e = 16, t = ys.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function yf(e) {
  return !!(e && xe(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const mf = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (Hn(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const i = rr(n) ? [] : {};
        return Ur(n, (s, l) => {
          const c = r(s, o + 1);
          !Nr(c) && (i[l] = c);
        }), t[o] = void 0, i;
      }
    }
    return n;
  };
  return r(e, 0);
}, gf = Me("AsyncFunction"), vf = (e) => e && (Hn(e) || xe(e)) && xe(e.then) && xe(e.catch), ms = ((e, t) => e ? setImmediate : t ? ((r, n) => (_t.addEventListener("message", ({ source: o, data: i }) => {
  o === _t && i === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), _t.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  xe(_t.postMessage)
), bf = typeof queueMicrotask < "u" ? queueMicrotask.bind(_t) : typeof process < "u" && process.nextTick || ms, b = {
  isArray: rr,
  isArrayBuffer: cs,
  isBuffer: Nc,
  isFormData: qc,
  isArrayBufferView: Ic,
  isString: Dc,
  isNumber: fs,
  isBoolean: Bc,
  isObject: Hn,
  isPlainObject: On,
  isReadableStream: Wc,
  isRequest: Gc,
  isResponse: Kc,
  isHeaders: Jc,
  isUndefined: Nr,
  isDate: Mc,
  isFile: jc,
  isBlob: Uc,
  isRegExp: uf,
  isFunction: xe,
  isStream: zc,
  isURLSearchParams: Vc,
  isTypedArray: nf,
  isFileList: Hc,
  forEach: Ur,
  merge: ca,
  extend: Qc,
  trim: Xc,
  stripBOM: Yc,
  inherits: Zc,
  toFlatObject: ef,
  kindOf: jn,
  kindOfTest: Me,
  endsWith: tf,
  toArray: rf,
  forEachEntry: of,
  matchAll: af,
  isHTMLForm: sf,
  hasOwnProperty: Qa,
  hasOwnProp: Qa,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: hs,
  freezeMethods: cf,
  toObjectSet: ff,
  toCamelCase: lf,
  noop: df,
  toFiniteNumber: pf,
  findKey: ds,
  global: _t,
  isContextDefined: ps,
  ALPHABET: ys,
  generateString: hf,
  isSpecCompliantForm: yf,
  toJSONObject: mf,
  isAsyncFn: gf,
  isThenable: vf,
  setImmediate: ms,
  asap: bf
};
function C(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
b.inherits(C, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: b.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const gs = C.prototype, vs = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  vs[e] = { value: e };
});
Object.defineProperties(C, vs);
Object.defineProperty(gs, "isAxiosError", { value: !0 });
C.from = (e, t, r, n, o, i) => {
  const s = Object.create(gs);
  return b.toFlatObject(e, s, function(c) {
    return c !== Error.prototype;
  }, (l) => l !== "isAxiosError"), C.call(s, e.message, t, r, n, o), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const wf = null;
function fa(e) {
  return b.isPlainObject(e) || b.isArray(e);
}
function bs(e) {
  return b.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Za(e, t, r) {
  return e ? e.concat(t).map(function(o, i) {
    return o = bs(o), !r && i ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function Sf(e) {
  return b.isArray(e) && !e.some(fa);
}
const Ef = b.toFlatObject(b, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function zn(e, t, r) {
  if (!b.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = b.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, v) {
    return !b.isUndefined(v[y]);
  });
  const n = r.metaTokens, o = r.visitor || d, i = r.dots, s = r.indexes, c = (r.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(t);
  if (!b.isFunction(o))
    throw new TypeError("visitor must be a function");
  function f(h) {
    if (h === null) return "";
    if (b.isDate(h))
      return h.toISOString();
    if (!c && b.isBlob(h))
      throw new C("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(h) || b.isTypedArray(h) ? c && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function d(h, y, v) {
    let _ = h;
    if (h && !v && typeof h == "object") {
      if (b.endsWith(y, "{}"))
        y = n ? y : y.slice(0, -2), h = JSON.stringify(h);
      else if (b.isArray(h) && Sf(h) || (b.isFileList(h) || b.endsWith(y, "[]")) && (_ = b.toArray(h)))
        return y = bs(y), _.forEach(function(E, O) {
          !(b.isUndefined(E) || E === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Za([y], O, i) : s === null ? y : y + "[]",
            f(E)
          );
        }), !1;
    }
    return fa(h) ? !0 : (t.append(Za(v, y, i), f(h)), !1);
  }
  const g = [], m = Object.assign(Ef, {
    defaultVisitor: d,
    convertValue: f,
    isVisitable: fa
  });
  function S(h, y) {
    if (!b.isUndefined(h)) {
      if (g.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      g.push(h), b.forEach(h, function(_, T) {
        (!(b.isUndefined(_) || _ === null) && o.call(
          t,
          _,
          b.isString(T) ? T.trim() : T,
          y,
          m
        )) === !0 && S(_, y ? y.concat(T) : [T]);
      }), g.pop();
    }
  }
  if (!b.isObject(e))
    throw new TypeError("data must be an object");
  return S(e), t;
}
function ei(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Ca(e, t) {
  this._pairs = [], e && zn(e, this, t);
}
const ws = Ca.prototype;
ws.append = function(t, r) {
  this._pairs.push([t, r]);
};
ws.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, ei);
  } : ei;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function _f(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Ss(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || _f, o = r && r.serialize;
  let i;
  if (o ? i = o(t, r) : i = b.isURLSearchParams(t) ? t.toString() : new Ca(t, r).toString(n), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class ti {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    b.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Es = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Tf = typeof URLSearchParams < "u" ? URLSearchParams : Ca, Of = typeof FormData < "u" ? FormData : null, Af = typeof Blob < "u" ? Blob : null, xf = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Tf,
    FormData: Of,
    Blob: Af
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Fa = typeof window < "u" && typeof document < "u", da = typeof navigator == "object" && navigator || void 0, Pf = Fa && (!da || ["ReactNative", "NativeScript", "NS"].indexOf(da.product) < 0), $f = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Rf = Fa && window.location.href || "http://localhost", kf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Fa,
  hasStandardBrowserEnv: Pf,
  hasStandardBrowserWebWorkerEnv: $f,
  navigator: da,
  origin: Rf
}, Symbol.toStringTag, { value: "Module" })), _e = {
  ...kf,
  ...xf
};
function Cf(e, t) {
  return zn(e, new _e.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, i) {
      return _e.isNode && b.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Ff(e) {
  return b.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Lf(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let i;
  for (n = 0; n < o; n++)
    i = r[n], t[i] = e[i];
  return t;
}
function _s(e) {
  function t(r, n, o, i) {
    let s = r[i++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), c = i >= r.length;
    return s = !s && b.isArray(o) ? o.length : s, c ? (b.hasOwnProp(o, s) ? o[s] = [o[s], n] : o[s] = n, !l) : ((!o[s] || !b.isObject(o[s])) && (o[s] = []), t(r, n, o[s], i) && b.isArray(o[s]) && (o[s] = Lf(o[s])), !l);
  }
  if (b.isFormData(e) && b.isFunction(e.entries)) {
    const r = {};
    return b.forEachEntry(e, (n, o) => {
      t(Ff(n), o, r, 0);
    }), r;
  }
  return null;
}
function Nf(e, t, r) {
  if (b.isString(e))
    try {
      return (t || JSON.parse)(e), b.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(e);
}
const Hr = {
  transitional: Es,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, i = b.isObject(t);
    if (i && b.isHTMLForm(t) && (t = new FormData(t)), b.isFormData(t))
      return o ? JSON.stringify(_s(t)) : t;
    if (b.isArrayBuffer(t) || b.isBuffer(t) || b.isStream(t) || b.isFile(t) || b.isBlob(t) || b.isReadableStream(t))
      return t;
    if (b.isArrayBufferView(t))
      return t.buffer;
    if (b.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let l;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Cf(t, this.formSerializer).toString();
      if ((l = b.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return zn(
          l ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return i || o ? (r.setContentType("application/json", !1), Nf(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Hr.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (b.isResponse(t) || b.isReadableStream(t))
      return t;
    if (t && b.isString(t) && (n && !this.responseType || o)) {
      const s = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? C.from(l, C.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: _e.classes.FormData,
    Blob: _e.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
b.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Hr.headers[e] = {};
});
const If = b.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Df = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(s) {
    o = s.indexOf(":"), r = s.substring(0, o).trim().toLowerCase(), n = s.substring(o + 1).trim(), !(!r || t[r] && If[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, ri = Symbol("internals");
function xr(e) {
  return e && String(e).trim().toLowerCase();
}
function An(e) {
  return e === !1 || e == null ? e : b.isArray(e) ? e.map(An) : String(e);
}
function Bf(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Mf = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Bo(e, t, r, n, o) {
  if (b.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!b.isString(t)) {
    if (b.isString(n))
      return t.indexOf(n) !== -1;
    if (b.isRegExp(n))
      return n.test(t);
  }
}
function jf(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Uf(e, t) {
  const r = b.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, i, s) {
        return this[n].call(this, t, o, i, s);
      },
      configurable: !0
    });
  });
}
class Te {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function i(l, c, f) {
      const d = xr(c);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const g = b.findKey(o, d);
      (!g || o[g] === void 0 || f === !0 || f === void 0 && o[g] !== !1) && (o[g || c] = An(l));
    }
    const s = (l, c) => b.forEach(l, (f, d) => i(f, d, c));
    if (b.isPlainObject(t) || t instanceof this.constructor)
      s(t, r);
    else if (b.isString(t) && (t = t.trim()) && !Mf(t))
      s(Df(t), r);
    else if (b.isHeaders(t))
      for (const [l, c] of t.entries())
        i(c, l, n);
    else
      t != null && i(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = xr(t), t) {
      const n = b.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return Bf(o);
        if (b.isFunction(r))
          return r.call(this, o, n);
        if (b.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = xr(t), t) {
      const n = b.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Bo(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function i(s) {
      if (s = xr(s), s) {
        const l = b.findKey(n, s);
        l && (!r || Bo(n, n[l], l, r)) && (delete n[l], o = !0);
      }
    }
    return b.isArray(t) ? t.forEach(i) : i(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const i = r[n];
      (!t || Bo(this, this[i], i, t, !0)) && (delete this[i], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return b.forEach(this, (o, i) => {
      const s = b.findKey(n, i);
      if (s) {
        r[s] = An(o), delete r[i];
        return;
      }
      const l = t ? jf(i) : String(i).trim();
      l !== i && delete r[i], r[l] = An(o), n[l] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && b.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[ri] = this[ri] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function i(s) {
      const l = xr(s);
      n[l] || (Uf(o, s), n[l] = !0);
    }
    return b.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
Te.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
b.reduceDescriptors(Te.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
b.freezeMethods(Te);
function Mo(e, t) {
  const r = this || Hr, n = t || r, o = Te.from(n.headers);
  let i = n.data;
  return b.forEach(e, function(l) {
    i = l.call(r, i, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), i;
}
function Ts(e) {
  return !!(e && e.__CANCEL__);
}
function nr(e, t, r) {
  C.call(this, e ?? "canceled", C.ERR_CANCELED, t, r), this.name = "CanceledError";
}
b.inherits(nr, C, {
  __CANCEL__: !0
});
function Os(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new C(
    "Request failed with status code " + r.status,
    [C.ERR_BAD_REQUEST, C.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Hf(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function zf(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const f = Date.now(), d = n[i];
    s || (s = f), r[o] = c, n[o] = f;
    let g = i, m = 0;
    for (; g !== o; )
      m += r[g++], g = g % e;
    if (o = (o + 1) % e, o === i && (i = (i + 1) % e), f - s < t)
      return;
    const S = d && f - d;
    return S ? Math.round(m * 1e3 / S) : void 0;
  };
}
function qf(e, t) {
  let r = 0, n = 1e3 / t, o, i;
  const s = (f, d = Date.now()) => {
    r = d, o = null, i && (clearTimeout(i), i = null), e.apply(null, f);
  };
  return [(...f) => {
    const d = Date.now(), g = d - r;
    g >= n ? s(f, d) : (o = f, i || (i = setTimeout(() => {
      i = null, s(o);
    }, n - g)));
  }, () => o && s(o)];
}
const kn = (e, t, r = 3) => {
  let n = 0;
  const o = zf(50, 250);
  return qf((i) => {
    const s = i.loaded, l = i.lengthComputable ? i.total : void 0, c = s - n, f = o(c), d = s <= l;
    n = s;
    const g = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: c,
      rate: f || void 0,
      estimated: f && l && d ? (l - s) / f : void 0,
      event: i,
      lengthComputable: l != null,
      [t ? "download" : "upload"]: !0
    };
    e(g);
  }, r);
}, ni = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, oi = (e) => (...t) => b.asap(() => e(...t)), Vf = _e.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = _e.navigator && /(msie|trident)/i.test(_e.navigator.userAgent), r = document.createElement("a");
    let n;
    function o(i) {
      let s = i;
      return t && (r.setAttribute("href", s), s = r.href), r.setAttribute("href", s), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = o(window.location.href), function(s) {
      const l = b.isString(s) ? o(s) : s;
      return l.protocol === n.protocol && l.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Wf = _e.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      b.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), b.isString(n) && s.push("path=" + n), b.isString(o) && s.push("domain=" + o), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Gf(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Kf(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function As(e, t) {
  return e && !Gf(t) ? Kf(e, t) : t;
}
const ai = (e) => e instanceof Te ? { ...e } : e;
function $t(e, t) {
  t = t || {};
  const r = {};
  function n(f, d, g) {
    return b.isPlainObject(f) && b.isPlainObject(d) ? b.merge.call({ caseless: g }, f, d) : b.isPlainObject(d) ? b.merge({}, d) : b.isArray(d) ? d.slice() : d;
  }
  function o(f, d, g) {
    if (b.isUndefined(d)) {
      if (!b.isUndefined(f))
        return n(void 0, f, g);
    } else return n(f, d, g);
  }
  function i(f, d) {
    if (!b.isUndefined(d))
      return n(void 0, d);
  }
  function s(f, d) {
    if (b.isUndefined(d)) {
      if (!b.isUndefined(f))
        return n(void 0, f);
    } else return n(void 0, d);
  }
  function l(f, d, g) {
    if (g in t)
      return n(f, d);
    if (g in e)
      return n(void 0, f);
  }
  const c = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (f, d) => o(ai(f), ai(d), !0)
  };
  return b.forEach(Object.keys(Object.assign({}, e, t)), function(d) {
    const g = c[d] || o, m = g(e[d], t[d], d);
    b.isUndefined(m) && g !== l || (r[d] = m);
  }), r;
}
const xs = (e) => {
  const t = $t({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: i, headers: s, auth: l } = t;
  t.headers = s = Te.from(s), t.url = Ss(As(t.baseURL, t.url), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  );
  let c;
  if (b.isFormData(r)) {
    if (_e.hasStandardBrowserEnv || _e.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((c = s.getContentType()) !== !1) {
      const [f, ...d] = c ? c.split(";").map((g) => g.trim()).filter(Boolean) : [];
      s.setContentType([f || "multipart/form-data", ...d].join("; "));
    }
  }
  if (_e.hasStandardBrowserEnv && (n && b.isFunction(n) && (n = n(t)), n || n !== !1 && Vf(t.url))) {
    const f = o && i && Wf.read(i);
    f && s.set(o, f);
  }
  return t;
}, Jf = typeof XMLHttpRequest < "u", Xf = Jf && function(e) {
  return new Promise(function(r, n) {
    const o = xs(e);
    let i = o.data;
    const s = Te.from(o.headers).normalize();
    let { responseType: l, onUploadProgress: c, onDownloadProgress: f } = o, d, g, m, S, h;
    function y() {
      S && S(), h && h(), o.cancelToken && o.cancelToken.unsubscribe(d), o.signal && o.signal.removeEventListener("abort", d);
    }
    let v = new XMLHttpRequest();
    v.open(o.method.toUpperCase(), o.url, !0), v.timeout = o.timeout;
    function _() {
      if (!v)
        return;
      const E = Te.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), P = {
        data: !l || l === "text" || l === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: E,
        config: e,
        request: v
      };
      Os(function(D) {
        r(D), y();
      }, function(D) {
        n(D), y();
      }, P), v = null;
    }
    "onloadend" in v ? v.onloadend = _ : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, v.onabort = function() {
      v && (n(new C("Request aborted", C.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function() {
      n(new C("Network Error", C.ERR_NETWORK, e, v)), v = null;
    }, v.ontimeout = function() {
      let O = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const P = o.transitional || Es;
      o.timeoutErrorMessage && (O = o.timeoutErrorMessage), n(new C(
        O,
        P.clarifyTimeoutError ? C.ETIMEDOUT : C.ECONNABORTED,
        e,
        v
      )), v = null;
    }, i === void 0 && s.setContentType(null), "setRequestHeader" in v && b.forEach(s.toJSON(), function(O, P) {
      v.setRequestHeader(P, O);
    }), b.isUndefined(o.withCredentials) || (v.withCredentials = !!o.withCredentials), l && l !== "json" && (v.responseType = o.responseType), f && ([m, h] = kn(f, !0), v.addEventListener("progress", m)), c && v.upload && ([g, S] = kn(c), v.upload.addEventListener("progress", g), v.upload.addEventListener("loadend", S)), (o.cancelToken || o.signal) && (d = (E) => {
      v && (n(!E || E.type ? new nr(null, e, v) : E), v.abort(), v = null);
    }, o.cancelToken && o.cancelToken.subscribe(d), o.signal && (o.signal.aborted ? d() : o.signal.addEventListener("abort", d)));
    const T = Hf(o.url);
    if (T && _e.protocols.indexOf(T) === -1) {
      n(new C("Unsupported protocol " + T + ":", C.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(i || null);
  });
}, Qf = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const i = function(f) {
      if (!o) {
        o = !0, l();
        const d = f instanceof Error ? f : this.reason;
        n.abort(d instanceof C ? d : new nr(d instanceof Error ? d.message : d));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new C(`timeout ${t} of ms exceeded`, C.ETIMEDOUT));
    }, t);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((f) => {
        f.unsubscribe ? f.unsubscribe(i) : f.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((f) => f.addEventListener("abort", i));
    const { signal: c } = n;
    return c.unsubscribe = () => b.asap(l), c;
  }
}, Yf = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, Zf = async function* (e, t) {
  for await (const r of ed(e))
    yield* Yf(r, t);
}, ed = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, ii = (e, t, r, n) => {
  const o = Zf(e, t);
  let i = 0, s, l = (c) => {
    s || (s = !0, n && n(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: f, value: d } = await o.next();
        if (f) {
          l(), c.close();
          return;
        }
        let g = d.byteLength;
        if (r) {
          let m = i += g;
          r(m);
        }
        c.enqueue(new Uint8Array(d));
      } catch (f) {
        throw l(f), f;
      }
    },
    cancel(c) {
      return l(c), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, qn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Ps = qn && typeof ReadableStream == "function", td = qn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), $s = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, rd = Ps && $s(() => {
  let e = !1;
  const t = new Request(_e.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), si = 64 * 1024, pa = Ps && $s(() => b.isReadableStream(new Response("").body)), Cn = {
  stream: pa && ((e) => e.body)
};
qn && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Cn[t] && (Cn[t] = b.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new C(`Response type '${t}' is not supported`, C.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const nd = async (e) => {
  if (e == null)
    return 0;
  if (b.isBlob(e))
    return e.size;
  if (b.isSpecCompliantForm(e))
    return (await new Request(_e.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (b.isArrayBufferView(e) || b.isArrayBuffer(e))
    return e.byteLength;
  if (b.isURLSearchParams(e) && (e = e + ""), b.isString(e))
    return (await td(e)).byteLength;
}, od = async (e, t) => {
  const r = b.toFiniteNumber(e.getContentLength());
  return r ?? nd(t);
}, ad = qn && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: o,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: l,
    onUploadProgress: c,
    responseType: f,
    headers: d,
    withCredentials: g = "same-origin",
    fetchOptions: m
  } = xs(e);
  f = f ? (f + "").toLowerCase() : "text";
  let S = Qf([o, i && i.toAbortSignal()], s), h;
  const y = S && S.unsubscribe && (() => {
    S.unsubscribe();
  });
  let v;
  try {
    if (c && rd && r !== "get" && r !== "head" && (v = await od(d, n)) !== 0) {
      let P = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), $;
      if (b.isFormData(n) && ($ = P.headers.get("content-type")) && d.setContentType($), P.body) {
        const [D, A] = ni(
          v,
          kn(oi(c))
        );
        n = ii(P.body, si, D, A);
      }
    }
    b.isString(g) || (g = g ? "include" : "omit");
    const _ = "credentials" in Request.prototype;
    h = new Request(t, {
      ...m,
      signal: S,
      method: r.toUpperCase(),
      headers: d.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: _ ? g : void 0
    });
    let T = await fetch(h);
    const E = pa && (f === "stream" || f === "response");
    if (pa && (l || E && y)) {
      const P = {};
      ["status", "statusText", "headers"].forEach((k) => {
        P[k] = T[k];
      });
      const $ = b.toFiniteNumber(T.headers.get("content-length")), [D, A] = l && ni(
        $,
        kn(oi(l), !0)
      ) || [];
      T = new Response(
        ii(T.body, si, D, () => {
          A && A(), y && y();
        }),
        P
      );
    }
    f = f || "text";
    let O = await Cn[b.findKey(Cn, f) || "text"](T, e);
    return !E && y && y(), await new Promise((P, $) => {
      Os(P, $, {
        data: O,
        headers: Te.from(T.headers),
        status: T.status,
        statusText: T.statusText,
        config: e,
        request: h
      });
    });
  } catch (_) {
    throw y && y(), _ && _.name === "TypeError" && /fetch/i.test(_.message) ? Object.assign(
      new C("Network Error", C.ERR_NETWORK, e, h),
      {
        cause: _.cause || _
      }
    ) : C.from(_, _ && _.code, e, h);
  }
}), ha = {
  http: wf,
  xhr: Xf,
  fetch: ad
};
b.forEach(ha, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const li = (e) => `- ${e}`, id = (e) => b.isFunction(e) || e === null || e === !1, Rs = {
  getAdapter: (e) => {
    e = b.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let i = 0; i < t; i++) {
      r = e[i];
      let s;
      if (n = r, !id(r) && (n = ha[(s = String(r)).toLowerCase()], n === void 0))
        throw new C(`Unknown adapter '${s}'`);
      if (n)
        break;
      o[s || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(o).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(li).join(`
`) : " " + li(i[0]) : "as no adapter specified";
      throw new C(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: ha
};
function jo(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new nr(null, e);
}
function ui(e) {
  return jo(e), e.headers = Te.from(e.headers), e.data = Mo.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Rs.getAdapter(e.adapter || Hr.adapter)(e).then(function(n) {
    return jo(e), n.data = Mo.call(
      e,
      e.transformResponse,
      n
    ), n.headers = Te.from(n.headers), n;
  }, function(n) {
    return Ts(n) || (jo(e), n && n.response && (n.response.data = Mo.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = Te.from(n.response.headers))), Promise.reject(n);
  });
}
const ks = "1.7.7", La = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  La[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ci = {};
La.transitional = function(t, r, n) {
  function o(i, s) {
    return "[Axios v" + ks + "] Transitional option '" + i + "'" + s + (n ? ". " + n : "");
  }
  return (i, s, l) => {
    if (t === !1)
      throw new C(
        o(s, " has been removed" + (r ? " in " + r : "")),
        C.ERR_DEPRECATED
      );
    return r && !ci[s] && (ci[s] = !0, console.warn(
      o(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(i, s, l) : !0;
  };
};
function sd(e, t, r) {
  if (typeof e != "object")
    throw new C("options must be an object", C.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const i = n[o], s = t[i];
    if (s) {
      const l = e[i], c = l === void 0 || s(l, i, e);
      if (c !== !0)
        throw new C("option " + i + " must be " + c, C.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new C("Unknown option " + i, C.ERR_BAD_OPTION);
  }
}
const ya = {
  assertOptions: sd,
  validators: La
}, ot = ya.validators;
class At {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new ti(),
      response: new ti()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const i = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = $t(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: i } = r;
    n !== void 0 && ya.assertOptions(n, {
      silentJSONParsing: ot.transitional(ot.boolean),
      forcedJSONParsing: ot.transitional(ot.boolean),
      clarifyTimeoutError: ot.transitional(ot.boolean)
    }, !1), o != null && (b.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : ya.assertOptions(o, {
      encode: ot.function,
      serialize: ot.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = i && b.merge(
      i.common,
      i[r.method]
    );
    i && b.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), r.headers = Te.concat(s, i);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(r) === !1 || (c = c && y.synchronous, l.unshift(y.fulfilled, y.rejected));
    });
    const f = [];
    this.interceptors.response.forEach(function(y) {
      f.push(y.fulfilled, y.rejected);
    });
    let d, g = 0, m;
    if (!c) {
      const h = [ui.bind(this), void 0];
      for (h.unshift.apply(h, l), h.push.apply(h, f), m = h.length, d = Promise.resolve(r); g < m; )
        d = d.then(h[g++], h[g++]);
      return d;
    }
    m = l.length;
    let S = r;
    for (g = 0; g < m; ) {
      const h = l[g++], y = l[g++];
      try {
        S = h(S);
      } catch (v) {
        y.call(this, v);
        break;
      }
    }
    try {
      d = ui.call(this, S);
    } catch (h) {
      return Promise.reject(h);
    }
    for (g = 0, m = f.length; g < m; )
      d = d.then(f[g++], f[g++]);
    return d;
  }
  getUri(t) {
    t = $t(this.defaults, t);
    const r = As(t.baseURL, t.url);
    return Ss(r, t.params, t.paramsSerializer);
  }
}
b.forEach(["delete", "get", "head", "options"], function(t) {
  At.prototype[t] = function(r, n) {
    return this.request($t(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
b.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(i, s, l) {
      return this.request($t(l || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  At.prototype[t] = r(), At.prototype[t + "Form"] = r(!0);
});
class Na {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let i;
      const s = new Promise((l) => {
        n.subscribe(l), i = l;
      }).then(o);
      return s.cancel = function() {
        n.unsubscribe(i);
      }, s;
    }, t(function(i, s, l) {
      n.reason || (n.reason = new nr(i, s, l), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Na(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function ld(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function ud(e) {
  return b.isObject(e) && e.isAxiosError === !0;
}
const ma = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ma).forEach(([e, t]) => {
  ma[t] = e;
});
function Cs(e) {
  const t = new At(e), r = us(At.prototype.request, t);
  return b.extend(r, At.prototype, t, { allOwnKeys: !0 }), b.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return Cs($t(e, o));
  }, r;
}
const re = Cs(Hr);
re.Axios = At;
re.CanceledError = nr;
re.CancelToken = Na;
re.isCancel = Ts;
re.VERSION = ks;
re.toFormData = zn;
re.AxiosError = C;
re.Cancel = re.CanceledError;
re.all = function(t) {
  return Promise.all(t);
};
re.spread = ld;
re.isAxiosError = ud;
re.mergeConfig = $t;
re.AxiosHeaders = Te;
re.formToJSON = (e) => _s(b.isHTMLForm(e) ? new FormData(e) : e);
re.getAdapter = Rs.getAdapter;
re.HttpStatusCode = ma;
re.default = re;
var Ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function cd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function fd(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var dd = function(t) {
  return pd(t) && !hd(t);
};
function pd(e) {
  return !!e && typeof e == "object";
}
function hd(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || gd(e);
}
var yd = typeof Symbol == "function" && Symbol.for, md = yd ? Symbol.for("react.element") : 60103;
function gd(e) {
  return e.$$typeof === md;
}
function vd(e) {
  return Array.isArray(e) ? [] : {};
}
function Ir(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? Xt(vd(e), e, t) : e;
}
function bd(e, t, r) {
  return e.concat(t).map(function(n) {
    return Ir(n, r);
  });
}
function wd(e, t) {
  if (!t.customMerge)
    return Xt;
  var r = t.customMerge(e);
  return typeof r == "function" ? r : Xt;
}
function Sd(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function fi(e) {
  return Object.keys(e).concat(Sd(e));
}
function Fs(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function Ed(e, t) {
  return Fs(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function _d(e, t, r) {
  var n = {};
  return r.isMergeableObject(e) && fi(e).forEach(function(o) {
    n[o] = Ir(e[o], r);
  }), fi(t).forEach(function(o) {
    Ed(e, o) || (Fs(e, o) && r.isMergeableObject(t[o]) ? n[o] = wd(o, r)(e[o], t[o], r) : n[o] = Ir(t[o], r));
  }), n;
}
function Xt(e, t, r) {
  r = r || {}, r.arrayMerge = r.arrayMerge || bd, r.isMergeableObject = r.isMergeableObject || dd, r.cloneUnlessOtherwiseSpecified = Ir;
  var n = Array.isArray(t), o = Array.isArray(e), i = n === o;
  return i ? n ? r.arrayMerge(e, t, r) : _d(e, t, r) : Ir(t, r);
}
Xt.all = function(t, r) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(n, o) {
    return Xt(n, o, r);
  }, {});
};
var Td = Xt, Od = Td;
const Ad = /* @__PURE__ */ cd(Od);
var xd = Error, Pd = EvalError, $d = RangeError, Rd = ReferenceError, Ls = SyntaxError, zr = TypeError, kd = URIError, Cd = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var t = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var o = 42;
  t[r] = o;
  for (r in t)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
    return !1;
  var i = Object.getOwnPropertySymbols(t);
  if (i.length !== 1 || i[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var s = Object.getOwnPropertyDescriptor(t, r);
    if (s.value !== o || s.enumerable !== !0)
      return !1;
  }
  return !0;
}, di = typeof Symbol < "u" && Symbol, Fd = Cd, Ld = function() {
  return typeof di != "function" || typeof Symbol != "function" || typeof di("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Fd();
}, Uo = {
  __proto__: null,
  foo: {}
}, Nd = Object, Id = function() {
  return { __proto__: Uo }.foo === Uo.foo && !(Uo instanceof Nd);
}, Dd = "Function.prototype.bind called on incompatible ", Bd = Object.prototype.toString, Md = Math.max, jd = "[object Function]", pi = function(t, r) {
  for (var n = [], o = 0; o < t.length; o += 1)
    n[o] = t[o];
  for (var i = 0; i < r.length; i += 1)
    n[i + t.length] = r[i];
  return n;
}, Ud = function(t, r) {
  for (var n = [], o = r, i = 0; o < t.length; o += 1, i += 1)
    n[i] = t[o];
  return n;
}, Hd = function(e, t) {
  for (var r = "", n = 0; n < e.length; n += 1)
    r += e[n], n + 1 < e.length && (r += t);
  return r;
}, zd = function(t) {
  var r = this;
  if (typeof r != "function" || Bd.apply(r) !== jd)
    throw new TypeError(Dd + r);
  for (var n = Ud(arguments, 1), o, i = function() {
    if (this instanceof o) {
      var d = r.apply(
        this,
        pi(n, arguments)
      );
      return Object(d) === d ? d : this;
    }
    return r.apply(
      t,
      pi(n, arguments)
    );
  }, s = Md(0, r.length - n.length), l = [], c = 0; c < s; c++)
    l[c] = "$" + c;
  if (o = Function("binder", "return function (" + Hd(l, ",") + "){ return binder.apply(this,arguments); }")(i), r.prototype) {
    var f = function() {
    };
    f.prototype = r.prototype, o.prototype = new f(), f.prototype = null;
  }
  return o;
}, qd = zd, Ia = Function.prototype.bind || qd, Vd = Function.prototype.call, Wd = Object.prototype.hasOwnProperty, Gd = Ia, Kd = Gd.call(Vd, Wd), N, Jd = xd, Xd = Pd, Qd = $d, Yd = Rd, Qt = Ls, Kt = zr, Zd = kd, Ns = Function, Ho = function(e) {
  try {
    return Ns('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, xt = Object.getOwnPropertyDescriptor;
if (xt)
  try {
    xt({}, "");
  } catch {
    xt = null;
  }
var zo = function() {
  throw new Kt();
}, ep = xt ? function() {
  try {
    return arguments.callee, zo;
  } catch {
    try {
      return xt(arguments, "callee").get;
    } catch {
      return zo;
    }
  }
}() : zo, zt = Ld(), tp = Id(), ce = Object.getPrototypeOf || (tp ? function(e) {
  return e.__proto__;
} : null), Gt = {}, rp = typeof Uint8Array > "u" || !ce ? N : ce(Uint8Array), Pt = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? N : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? N : ArrayBuffer,
  "%ArrayIteratorPrototype%": zt && ce ? ce([][Symbol.iterator]()) : N,
  "%AsyncFromSyncIteratorPrototype%": N,
  "%AsyncFunction%": Gt,
  "%AsyncGenerator%": Gt,
  "%AsyncGeneratorFunction%": Gt,
  "%AsyncIteratorPrototype%": Gt,
  "%Atomics%": typeof Atomics > "u" ? N : Atomics,
  "%BigInt%": typeof BigInt > "u" ? N : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? N : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? N : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? N : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Jd,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": Xd,
  "%Float32Array%": typeof Float32Array > "u" ? N : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? N : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? N : FinalizationRegistry,
  "%Function%": Ns,
  "%GeneratorFunction%": Gt,
  "%Int8Array%": typeof Int8Array > "u" ? N : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? N : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? N : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": zt && ce ? ce(ce([][Symbol.iterator]())) : N,
  "%JSON%": typeof JSON == "object" ? JSON : N,
  "%Map%": typeof Map > "u" ? N : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !zt || !ce ? N : ce((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? N : Promise,
  "%Proxy%": typeof Proxy > "u" ? N : Proxy,
  "%RangeError%": Qd,
  "%ReferenceError%": Yd,
  "%Reflect%": typeof Reflect > "u" ? N : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? N : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !zt || !ce ? N : ce((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? N : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": zt && ce ? ce(""[Symbol.iterator]()) : N,
  "%Symbol%": zt ? Symbol : N,
  "%SyntaxError%": Qt,
  "%ThrowTypeError%": ep,
  "%TypedArray%": rp,
  "%TypeError%": Kt,
  "%Uint8Array%": typeof Uint8Array > "u" ? N : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? N : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? N : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? N : Uint32Array,
  "%URIError%": Zd,
  "%WeakMap%": typeof WeakMap > "u" ? N : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? N : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? N : WeakSet
};
if (ce)
  try {
    null.error;
  } catch (e) {
    var np = ce(ce(e));
    Pt["%Error.prototype%"] = np;
  }
var op = function e(t) {
  var r;
  if (t === "%AsyncFunction%")
    r = Ho("async function () {}");
  else if (t === "%GeneratorFunction%")
    r = Ho("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    r = Ho("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var n = e("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var o = e("%AsyncGenerator%");
    o && ce && (r = ce(o.prototype));
  }
  return Pt[t] = r, r;
}, hi = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, qr = Ia, Fn = Kd, ap = qr.call(Function.call, Array.prototype.concat), ip = qr.call(Function.apply, Array.prototype.splice), yi = qr.call(Function.call, String.prototype.replace), Ln = qr.call(Function.call, String.prototype.slice), sp = qr.call(Function.call, RegExp.prototype.exec), lp = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, up = /\\(\\)?/g, cp = function(t) {
  var r = Ln(t, 0, 1), n = Ln(t, -1);
  if (r === "%" && n !== "%")
    throw new Qt("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Qt("invalid intrinsic syntax, expected opening `%`");
  var o = [];
  return yi(t, lp, function(i, s, l, c) {
    o[o.length] = l ? yi(c, up, "$1") : s || i;
  }), o;
}, fp = function(t, r) {
  var n = t, o;
  if (Fn(hi, n) && (o = hi[n], n = "%" + o[0] + "%"), Fn(Pt, n)) {
    var i = Pt[n];
    if (i === Gt && (i = op(n)), typeof i > "u" && !r)
      throw new Kt("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: o,
      name: n,
      value: i
    };
  }
  throw new Qt("intrinsic " + t + " does not exist!");
}, or = function(t, r) {
  if (typeof t != "string" || t.length === 0)
    throw new Kt("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Kt('"allowMissing" argument must be a boolean');
  if (sp(/^%?[^%]*%?$/, t) === null)
    throw new Qt("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = cp(t), o = n.length > 0 ? n[0] : "", i = fp("%" + o + "%", r), s = i.name, l = i.value, c = !1, f = i.alias;
  f && (o = f[0], ip(n, ap([0, 1], f)));
  for (var d = 1, g = !0; d < n.length; d += 1) {
    var m = n[d], S = Ln(m, 0, 1), h = Ln(m, -1);
    if ((S === '"' || S === "'" || S === "`" || h === '"' || h === "'" || h === "`") && S !== h)
      throw new Qt("property names with quotes must have matching quotes");
    if ((m === "constructor" || !g) && (c = !0), o += "." + m, s = "%" + o + "%", Fn(Pt, s))
      l = Pt[s];
    else if (l != null) {
      if (!(m in l)) {
        if (!r)
          throw new Kt("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (xt && d + 1 >= n.length) {
        var y = xt(l, m);
        g = !!y, g && "get" in y && !("originalValue" in y.get) ? l = y.get : l = l[m];
      } else
        g = Fn(l, m), l = l[m];
      g && !c && (Pt[s] = l);
    }
  }
  return l;
}, Is = { exports: {} }, qo, mi;
function Da() {
  if (mi) return qo;
  mi = 1;
  var e = or, t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return qo = t, qo;
}
var dp = or, xn = dp("%Object.getOwnPropertyDescriptor%", !0);
if (xn)
  try {
    xn([], "length");
  } catch {
    xn = null;
  }
var Ds = xn, gi = Da(), pp = Ls, qt = zr, vi = Ds, hp = function(t, r, n) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new qt("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new qt("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new qt("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new qt("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new qt("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new qt("`loose`, if provided, must be a boolean");
  var o = arguments.length > 3 ? arguments[3] : null, i = arguments.length > 4 ? arguments[4] : null, s = arguments.length > 5 ? arguments[5] : null, l = arguments.length > 6 ? arguments[6] : !1, c = !!vi && vi(t, r);
  if (gi)
    gi(t, r, {
      configurable: s === null && c ? c.configurable : !s,
      enumerable: o === null && c ? c.enumerable : !o,
      value: n,
      writable: i === null && c ? c.writable : !i
    });
  else if (l || !o && !i && !s)
    t[r] = n;
  else
    throw new pp("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, ga = Da(), Bs = function() {
  return !!ga;
};
Bs.hasArrayLengthDefineBug = function() {
  if (!ga)
    return null;
  try {
    return ga([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var yp = Bs, mp = or, bi = hp, gp = yp(), wi = Ds, Si = zr, vp = mp("%Math.floor%"), bp = function(t, r) {
  if (typeof t != "function")
    throw new Si("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || vp(r) !== r)
    throw new Si("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], o = !0, i = !0;
  if ("length" in t && wi) {
    var s = wi(t, "length");
    s && !s.configurable && (o = !1), s && !s.writable && (i = !1);
  }
  return (o || i || !n) && (gp ? bi(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    r,
    !0,
    !0
  ) : bi(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    r
  )), t;
};
(function(e) {
  var t = Ia, r = or, n = bp, o = zr, i = r("%Function.prototype.apply%"), s = r("%Function.prototype.call%"), l = r("%Reflect.apply%", !0) || t.call(s, i), c = Da(), f = r("%Math.max%");
  e.exports = function(m) {
    if (typeof m != "function")
      throw new o("a function is required");
    var S = l(t, s, arguments);
    return n(
      S,
      1 + f(0, m.length - (arguments.length - 1)),
      !0
    );
  };
  var d = function() {
    return l(t, i, arguments);
  };
  c ? c(e.exports, "apply", { value: d }) : e.exports.apply = d;
})(Is);
var wp = Is.exports, Ms = or, js = wp, Sp = js(Ms("String.prototype.indexOf")), Ep = function(t, r) {
  var n = Ms(t, !!r);
  return typeof n == "function" && Sp(t, ".prototype.") > -1 ? js(n) : n;
};
const _p = {}, Tp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _p
}, Symbol.toStringTag, { value: "Module" })), Op = /* @__PURE__ */ fd(Tp);
var Ba = typeof Map == "function" && Map.prototype, Vo = Object.getOwnPropertyDescriptor && Ba ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, Nn = Ba && Vo && typeof Vo.get == "function" ? Vo.get : null, Ei = Ba && Map.prototype.forEach, Ma = typeof Set == "function" && Set.prototype, Wo = Object.getOwnPropertyDescriptor && Ma ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, In = Ma && Wo && typeof Wo.get == "function" ? Wo.get : null, _i = Ma && Set.prototype.forEach, Ap = typeof WeakMap == "function" && WeakMap.prototype, Cr = Ap ? WeakMap.prototype.has : null, xp = typeof WeakSet == "function" && WeakSet.prototype, Fr = xp ? WeakSet.prototype.has : null, Pp = typeof WeakRef == "function" && WeakRef.prototype, Ti = Pp ? WeakRef.prototype.deref : null, $p = Boolean.prototype.valueOf, Rp = Object.prototype.toString, kp = Function.prototype.toString, Cp = String.prototype.match, ja = String.prototype.slice, ut = String.prototype.replace, Fp = String.prototype.toUpperCase, Oi = String.prototype.toLowerCase, Us = RegExp.prototype.test, Ai = Array.prototype.concat, We = Array.prototype.join, Lp = Array.prototype.slice, xi = Math.floor, va = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, Go = Object.getOwnPropertySymbols, ba = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Yt = typeof Symbol == "function" && typeof Symbol.iterator == "object", ve = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Yt || !0) ? Symbol.toStringTag : null, Hs = Object.prototype.propertyIsEnumerable, Pi = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function $i(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || Us.call(/e/, t))
    return t;
  var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var n = e < 0 ? -xi(-e) : xi(e);
    if (n !== e) {
      var o = String(n), i = ja.call(t, o.length + 1);
      return ut.call(o, r, "$&_") + "." + ut.call(ut.call(i, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ut.call(t, r, "$&_");
}
var wa = Op, Ri = wa.custom, ki = qs(Ri) ? Ri : null, Np = function e(t, r, n, o) {
  var i = r || {};
  if (it(i, "quoteStyle") && i.quoteStyle !== "single" && i.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (it(i, "maxStringLength") && (typeof i.maxStringLength == "number" ? i.maxStringLength < 0 && i.maxStringLength !== 1 / 0 : i.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var s = it(i, "customInspect") ? i.customInspect : !0;
  if (typeof s != "boolean" && s !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (it(i, "indent") && i.indent !== null && i.indent !== "	" && !(parseInt(i.indent, 10) === i.indent && i.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (it(i, "numericSeparator") && typeof i.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var l = i.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return Ws(t, i);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var c = String(t);
    return l ? $i(t, c) : c;
  }
  if (typeof t == "bigint") {
    var f = String(t) + "n";
    return l ? $i(t, f) : f;
  }
  var d = typeof i.depth > "u" ? 5 : i.depth;
  if (typeof n > "u" && (n = 0), n >= d && d > 0 && typeof t == "object")
    return Sa(t) ? "[Array]" : "[Object]";
  var g = Zp(i, n);
  if (typeof o > "u")
    o = [];
  else if (Vs(o, t) >= 0)
    return "[Circular]";
  function m(K, ie, Q) {
    if (ie && (o = Lp.call(o), o.push(ie)), Q) {
      var se = {
        depth: i.depth
      };
      return it(i, "quoteStyle") && (se.quoteStyle = i.quoteStyle), e(K, se, n + 1, o);
    }
    return e(K, i, n + 1, o);
  }
  if (typeof t == "function" && !Ci(t)) {
    var S = qp(t), h = vn(t, m);
    return "[Function" + (S ? ": " + S : " (anonymous)") + "]" + (h.length > 0 ? " { " + We.call(h, ", ") + " }" : "");
  }
  if (qs(t)) {
    var y = Yt ? ut.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : ba.call(t);
    return typeof t == "object" && !Yt ? Pr(y) : y;
  }
  if (Xp(t)) {
    for (var v = "<" + Oi.call(String(t.nodeName)), _ = t.attributes || [], T = 0; T < _.length; T++)
      v += " " + _[T].name + "=" + zs(Ip(_[T].value), "double", i);
    return v += ">", t.childNodes && t.childNodes.length && (v += "..."), v += "</" + Oi.call(String(t.nodeName)) + ">", v;
  }
  if (Sa(t)) {
    if (t.length === 0)
      return "[]";
    var E = vn(t, m);
    return g && !Yp(E) ? "[" + Ea(E, g) + "]" : "[ " + We.call(E, ", ") + " ]";
  }
  if (Bp(t)) {
    var O = vn(t, m);
    return !("cause" in Error.prototype) && "cause" in t && !Hs.call(t, "cause") ? "{ [" + String(t) + "] " + We.call(Ai.call("[cause]: " + m(t.cause), O), ", ") + " }" : O.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + We.call(O, ", ") + " }";
  }
  if (typeof t == "object" && s) {
    if (ki && typeof t[ki] == "function" && wa)
      return wa(t, { depth: d - n });
    if (s !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (Vp(t)) {
    var P = [];
    return Ei && Ei.call(t, function(K, ie) {
      P.push(m(ie, t, !0) + " => " + m(K, t));
    }), Fi("Map", Nn.call(t), P, g);
  }
  if (Kp(t)) {
    var $ = [];
    return _i && _i.call(t, function(K) {
      $.push(m(K, t));
    }), Fi("Set", In.call(t), $, g);
  }
  if (Wp(t))
    return Ko("WeakMap");
  if (Jp(t))
    return Ko("WeakSet");
  if (Gp(t))
    return Ko("WeakRef");
  if (jp(t))
    return Pr(m(Number(t)));
  if (Hp(t))
    return Pr(m(va.call(t)));
  if (Up(t))
    return Pr($p.call(t));
  if (Mp(t))
    return Pr(m(String(t)));
  if (typeof window < "u" && t === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && t === globalThis || typeof Ie < "u" && t === Ie)
    return "{ [object globalThis] }";
  if (!Dp(t) && !Ci(t)) {
    var D = vn(t, m), A = Pi ? Pi(t) === Object.prototype : t instanceof Object || t.constructor === Object, k = t instanceof Object ? "" : "null prototype", W = !A && ve && Object(t) === t && ve in t ? ja.call(ct(t), 8, -1) : k ? "Object" : "", ae = A || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", te = ae + (W || k ? "[" + We.call(Ai.call([], W || [], k || []), ": ") + "] " : "");
    return D.length === 0 ? te + "{}" : g ? te + "{" + Ea(D, g) + "}" : te + "{ " + We.call(D, ", ") + " }";
  }
  return String(t);
};
function zs(e, t, r) {
  var n = (r.quoteStyle || t) === "double" ? '"' : "'";
  return n + e + n;
}
function Ip(e) {
  return ut.call(String(e), /"/g, "&quot;");
}
function Sa(e) {
  return ct(e) === "[object Array]" && (!ve || !(typeof e == "object" && ve in e));
}
function Dp(e) {
  return ct(e) === "[object Date]" && (!ve || !(typeof e == "object" && ve in e));
}
function Ci(e) {
  return ct(e) === "[object RegExp]" && (!ve || !(typeof e == "object" && ve in e));
}
function Bp(e) {
  return ct(e) === "[object Error]" && (!ve || !(typeof e == "object" && ve in e));
}
function Mp(e) {
  return ct(e) === "[object String]" && (!ve || !(typeof e == "object" && ve in e));
}
function jp(e) {
  return ct(e) === "[object Number]" && (!ve || !(typeof e == "object" && ve in e));
}
function Up(e) {
  return ct(e) === "[object Boolean]" && (!ve || !(typeof e == "object" && ve in e));
}
function qs(e) {
  if (Yt)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !ba)
    return !1;
  try {
    return ba.call(e), !0;
  } catch {
  }
  return !1;
}
function Hp(e) {
  if (!e || typeof e != "object" || !va)
    return !1;
  try {
    return va.call(e), !0;
  } catch {
  }
  return !1;
}
var zp = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function it(e, t) {
  return zp.call(e, t);
}
function ct(e) {
  return Rp.call(e);
}
function qp(e) {
  if (e.name)
    return e.name;
  var t = Cp.call(kp.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function Vs(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var r = 0, n = e.length; r < n; r++)
    if (e[r] === t)
      return r;
  return -1;
}
function Vp(e) {
  if (!Nn || !e || typeof e != "object")
    return !1;
  try {
    Nn.call(e);
    try {
      In.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function Wp(e) {
  if (!Cr || !e || typeof e != "object")
    return !1;
  try {
    Cr.call(e, Cr);
    try {
      Fr.call(e, Fr);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Gp(e) {
  if (!Ti || !e || typeof e != "object")
    return !1;
  try {
    return Ti.call(e), !0;
  } catch {
  }
  return !1;
}
function Kp(e) {
  if (!In || !e || typeof e != "object")
    return !1;
  try {
    In.call(e);
    try {
      Nn.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function Jp(e) {
  if (!Fr || !e || typeof e != "object")
    return !1;
  try {
    Fr.call(e, Fr);
    try {
      Cr.call(e, Cr);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function Xp(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function Ws(e, t) {
  if (e.length > t.maxStringLength) {
    var r = e.length - t.maxStringLength, n = "... " + r + " more character" + (r > 1 ? "s" : "");
    return Ws(ja.call(e, 0, t.maxStringLength), t) + n;
  }
  var o = ut.call(ut.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Qp);
  return zs(o, "single", t);
}
function Qp(e) {
  var t = e.charCodeAt(0), r = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return r ? "\\" + r : "\\x" + (t < 16 ? "0" : "") + Fp.call(t.toString(16));
}
function Pr(e) {
  return "Object(" + e + ")";
}
function Ko(e) {
  return e + " { ? }";
}
function Fi(e, t, r, n) {
  var o = n ? Ea(r, n) : We.call(r, ", ");
  return e + " (" + t + ") {" + o + "}";
}
function Yp(e) {
  for (var t = 0; t < e.length; t++)
    if (Vs(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function Zp(e, t) {
  var r;
  if (e.indent === "	")
    r = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    r = We.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: r,
    prev: We.call(Array(t + 1), r)
  };
}
function Ea(e, t) {
  if (e.length === 0)
    return "";
  var r = `
` + t.prev + t.base;
  return r + We.call(e, "," + r) + `
` + t.prev;
}
function vn(e, t) {
  var r = Sa(e), n = [];
  if (r) {
    n.length = e.length;
    for (var o = 0; o < e.length; o++)
      n[o] = it(e, o) ? t(e[o], e) : "";
  }
  var i = typeof Go == "function" ? Go(e) : [], s;
  if (Yt) {
    s = {};
    for (var l = 0; l < i.length; l++)
      s["$" + i[l]] = i[l];
  }
  for (var c in e)
    it(e, c) && (r && String(Number(c)) === c && c < e.length || Yt && s["$" + c] instanceof Symbol || (Us.call(/[^\w$]/, c) ? n.push(t(c, e) + ": " + t(e[c], e)) : n.push(c + ": " + t(e[c], e))));
  if (typeof Go == "function")
    for (var f = 0; f < i.length; f++)
      Hs.call(e, i[f]) && n.push("[" + t(i[f]) + "]: " + t(e[i[f]], e));
  return n;
}
var Gs = or, ar = Ep, eh = Np, th = zr, bn = Gs("%WeakMap%", !0), wn = Gs("%Map%", !0), rh = ar("WeakMap.prototype.get", !0), nh = ar("WeakMap.prototype.set", !0), oh = ar("WeakMap.prototype.has", !0), ah = ar("Map.prototype.get", !0), ih = ar("Map.prototype.set", !0), sh = ar("Map.prototype.has", !0), Ua = function(e, t) {
  for (var r = e, n; (n = r.next) !== null; r = n)
    if (n.key === t)
      return r.next = n.next, n.next = /** @type {NonNullable<typeof list.next>} */
      e.next, e.next = n, n;
}, lh = function(e, t) {
  var r = Ua(e, t);
  return r && r.value;
}, uh = function(e, t, r) {
  var n = Ua(e, t);
  n ? n.value = r : e.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: t,
    next: e.next,
    value: r
  };
}, ch = function(e, t) {
  return !!Ua(e, t);
}, fh = function() {
  var t, r, n, o = {
    assert: function(i) {
      if (!o.has(i))
        throw new th("Side channel does not contain " + eh(i));
    },
    get: function(i) {
      if (bn && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return rh(t, i);
      } else if (wn) {
        if (r)
          return ah(r, i);
      } else if (n)
        return lh(n, i);
    },
    has: function(i) {
      if (bn && i && (typeof i == "object" || typeof i == "function")) {
        if (t)
          return oh(t, i);
      } else if (wn) {
        if (r)
          return sh(r, i);
      } else if (n)
        return ch(n, i);
      return !1;
    },
    set: function(i, s) {
      bn && i && (typeof i == "object" || typeof i == "function") ? (t || (t = new bn()), nh(t, i, s)) : wn ? (r || (r = new wn()), ih(r, i, s)) : (n || (n = { key: {}, next: null }), uh(n, i, s));
    }
  };
  return o;
}, dh = String.prototype.replace, ph = /%20/g, Jo = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, Ha = {
  default: Jo.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return dh.call(e, ph, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: Jo.RFC1738,
  RFC3986: Jo.RFC3986
}, hh = Ha, Xo = Object.prototype.hasOwnProperty, St = Array.isArray, qe = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), yh = function(t) {
  for (; t.length > 1; ) {
    var r = t.pop(), n = r.obj[r.prop];
    if (St(n)) {
      for (var o = [], i = 0; i < n.length; ++i)
        typeof n[i] < "u" && o.push(n[i]);
      r.obj[r.prop] = o;
    }
  }
}, Ks = function(t, r) {
  for (var n = r && r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, o = 0; o < t.length; ++o)
    typeof t[o] < "u" && (n[o] = t[o]);
  return n;
}, mh = function e(t, r, n) {
  if (!r)
    return t;
  if (typeof r != "object") {
    if (St(t))
      t.push(r);
    else if (t && typeof t == "object")
      (n && (n.plainObjects || n.allowPrototypes) || !Xo.call(Object.prototype, r)) && (t[r] = !0);
    else
      return [t, r];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(r);
  var o = t;
  return St(t) && !St(r) && (o = Ks(t, n)), St(t) && St(r) ? (r.forEach(function(i, s) {
    if (Xo.call(t, s)) {
      var l = t[s];
      l && typeof l == "object" && i && typeof i == "object" ? t[s] = e(l, i, n) : t.push(i);
    } else
      t[s] = i;
  }), t) : Object.keys(r).reduce(function(i, s) {
    var l = r[s];
    return Xo.call(i, s) ? i[s] = e(i[s], l, n) : i[s] = l, i;
  }, o);
}, gh = function(t, r) {
  return Object.keys(r).reduce(function(n, o) {
    return n[o] = r[o], n;
  }, t);
}, vh = function(e, t, r) {
  var n = e.replace(/\+/g, " ");
  if (r === "iso-8859-1")
    return n.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(n);
  } catch {
    return n;
  }
}, Qo = 1024, bh = function(t, r, n, o, i) {
  if (t.length === 0)
    return t;
  var s = t;
  if (typeof t == "symbol" ? s = Symbol.prototype.toString.call(t) : typeof t != "string" && (s = String(t)), n === "iso-8859-1")
    return escape(s).replace(/%u[0-9a-f]{4}/gi, function(S) {
      return "%26%23" + parseInt(S.slice(2), 16) + "%3B";
    });
  for (var l = "", c = 0; c < s.length; c += Qo) {
    for (var f = s.length >= Qo ? s.slice(c, c + Qo) : s, d = [], g = 0; g < f.length; ++g) {
      var m = f.charCodeAt(g);
      if (m === 45 || m === 46 || m === 95 || m === 126 || m >= 48 && m <= 57 || m >= 65 && m <= 90 || m >= 97 && m <= 122 || i === hh.RFC1738 && (m === 40 || m === 41)) {
        d[d.length] = f.charAt(g);
        continue;
      }
      if (m < 128) {
        d[d.length] = qe[m];
        continue;
      }
      if (m < 2048) {
        d[d.length] = qe[192 | m >> 6] + qe[128 | m & 63];
        continue;
      }
      if (m < 55296 || m >= 57344) {
        d[d.length] = qe[224 | m >> 12] + qe[128 | m >> 6 & 63] + qe[128 | m & 63];
        continue;
      }
      g += 1, m = 65536 + ((m & 1023) << 10 | f.charCodeAt(g) & 1023), d[d.length] = qe[240 | m >> 18] + qe[128 | m >> 12 & 63] + qe[128 | m >> 6 & 63] + qe[128 | m & 63];
    }
    l += d.join("");
  }
  return l;
}, wh = function(t) {
  for (var r = [{ obj: { o: t }, prop: "o" }], n = [], o = 0; o < r.length; ++o)
    for (var i = r[o], s = i.obj[i.prop], l = Object.keys(s), c = 0; c < l.length; ++c) {
      var f = l[c], d = s[f];
      typeof d == "object" && d !== null && n.indexOf(d) === -1 && (r.push({ obj: s, prop: f }), n.push(d));
    }
  return yh(r), t;
}, Sh = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, Eh = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, _h = function(t, r) {
  return [].concat(t, r);
}, Th = function(t, r) {
  if (St(t)) {
    for (var n = [], o = 0; o < t.length; o += 1)
      n.push(r(t[o]));
    return n;
  }
  return r(t);
}, Js = {
  arrayToObject: Ks,
  assign: gh,
  combine: _h,
  compact: wh,
  decode: vh,
  encode: bh,
  isBuffer: Eh,
  isRegExp: Sh,
  maybeMap: Th,
  merge: mh
}, Xs = fh, Pn = Js, Lr = Ha, Oh = Object.prototype.hasOwnProperty, Qs = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, r) {
    return t + "[" + r + "]";
  },
  repeat: function(t) {
    return t;
  }
}, Ve = Array.isArray, Ah = Array.prototype.push, Ys = function(e, t) {
  Ah.apply(e, Ve(t) ? t : [t]);
}, xh = Date.prototype.toISOString, Li = Lr.default, ue = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: Pn.encode,
  encodeValuesOnly: !1,
  format: Li,
  formatter: Lr.formatters[Li],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return xh.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, Ph = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, Yo = {}, $h = function e(t, r, n, o, i, s, l, c, f, d, g, m, S, h, y, v, _, T) {
  for (var E = t, O = T, P = 0, $ = !1; (O = O.get(Yo)) !== void 0 && !$; ) {
    var D = O.get(t);
    if (P += 1, typeof D < "u") {
      if (D === P)
        throw new RangeError("Cyclic object value");
      $ = !0;
    }
    typeof O.get(Yo) > "u" && (P = 0);
  }
  if (typeof d == "function" ? E = d(r, E) : E instanceof Date ? E = S(E) : n === "comma" && Ve(E) && (E = Pn.maybeMap(E, function(B) {
    return B instanceof Date ? S(B) : B;
  })), E === null) {
    if (s)
      return f && !v ? f(r, ue.encoder, _, "key", h) : r;
    E = "";
  }
  if (Ph(E) || Pn.isBuffer(E)) {
    if (f) {
      var A = v ? r : f(r, ue.encoder, _, "key", h);
      return [y(A) + "=" + y(f(E, ue.encoder, _, "value", h))];
    }
    return [y(r) + "=" + y(String(E))];
  }
  var k = [];
  if (typeof E > "u")
    return k;
  var W;
  if (n === "comma" && Ve(E))
    v && f && (E = Pn.maybeMap(E, f)), W = [{ value: E.length > 0 ? E.join(",") || null : void 0 }];
  else if (Ve(d))
    W = d;
  else {
    var ae = Object.keys(E);
    W = g ? ae.sort(g) : ae;
  }
  var te = c ? r.replace(/\./g, "%2E") : r, K = o && Ve(E) && E.length === 1 ? te + "[]" : te;
  if (i && Ve(E) && E.length === 0)
    return K + "[]";
  for (var ie = 0; ie < W.length; ++ie) {
    var Q = W[ie], se = typeof Q == "object" && typeof Q.value < "u" ? Q.value : E[Q];
    if (!(l && se === null)) {
      var we = m && c ? Q.replace(/\./g, "%2E") : Q, tt = Ve(E) ? typeof n == "function" ? n(K, we) : K : K + (m ? "." + we : "[" + we + "]");
      T.set(t, P);
      var Ke = Xs();
      Ke.set(Yo, T), Ys(k, e(
        se,
        tt,
        n,
        o,
        i,
        s,
        l,
        c,
        n === "comma" && v && Ve(E) ? null : f,
        d,
        g,
        m,
        S,
        h,
        y,
        v,
        _,
        Ke
      ));
    }
  }
  return k;
}, Rh = function(t) {
  if (!t)
    return ue;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.encodeDotInKeys < "u" && typeof t.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var r = t.charset || ue.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = Lr.default;
  if (typeof t.format < "u") {
    if (!Oh.call(Lr.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    n = t.format;
  }
  var o = Lr.formatters[n], i = ue.filter;
  (typeof t.filter == "function" || Ve(t.filter)) && (i = t.filter);
  var s;
  if (t.arrayFormat in Qs ? s = t.arrayFormat : "indices" in t ? s = t.indices ? "indices" : "repeat" : s = ue.arrayFormat, "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var l = typeof t.allowDots > "u" ? t.encodeDotInKeys === !0 ? !0 : ue.allowDots : !!t.allowDots;
  return {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : ue.addQueryPrefix,
    allowDots: l,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : ue.allowEmptyArrays,
    arrayFormat: s,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : ue.charsetSentinel,
    commaRoundTrip: t.commaRoundTrip,
    delimiter: typeof t.delimiter > "u" ? ue.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : ue.encode,
    encodeDotInKeys: typeof t.encodeDotInKeys == "boolean" ? t.encodeDotInKeys : ue.encodeDotInKeys,
    encoder: typeof t.encoder == "function" ? t.encoder : ue.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : ue.encodeValuesOnly,
    filter: i,
    format: n,
    formatter: o,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : ue.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : ue.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : ue.strictNullHandling
  };
}, kh = function(e, t) {
  var r = e, n = Rh(t), o, i;
  typeof n.filter == "function" ? (i = n.filter, r = i("", r)) : Ve(n.filter) && (i = n.filter, o = i);
  var s = [];
  if (typeof r != "object" || r === null)
    return "";
  var l = Qs[n.arrayFormat], c = l === "comma" && n.commaRoundTrip;
  o || (o = Object.keys(r)), n.sort && o.sort(n.sort);
  for (var f = Xs(), d = 0; d < o.length; ++d) {
    var g = o[d];
    n.skipNulls && r[g] === null || Ys(s, $h(
      r[g],
      g,
      l,
      c,
      n.allowEmptyArrays,
      n.strictNullHandling,
      n.skipNulls,
      n.encodeDotInKeys,
      n.encode ? n.encoder : null,
      n.filter,
      n.sort,
      n.allowDots,
      n.serializeDate,
      n.format,
      n.formatter,
      n.encodeValuesOnly,
      n.charset,
      f
    ));
  }
  var m = s.join(n.delimiter), S = n.addQueryPrefix === !0 ? "?" : "";
  return n.charsetSentinel && (n.charset === "iso-8859-1" ? S += "utf8=%26%2310003%3B&" : S += "utf8=%E2%9C%93&"), m.length > 0 ? S + m : "";
}, Zt = Js, _a = Object.prototype.hasOwnProperty, Ch = Array.isArray, Z = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: Zt.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1
}, Fh = function(e) {
  return e.replace(/&#(\d+);/g, function(t, r) {
    return String.fromCharCode(parseInt(r, 10));
  });
}, Zs = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, Lh = "utf8=%26%2310003%3B", Nh = "utf8=%E2%9C%93", Ih = function(t, r) {
  var n = { __proto__: null }, o = r.ignoreQueryPrefix ? t.replace(/^\?/, "") : t;
  o = o.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var i = r.parameterLimit === 1 / 0 ? void 0 : r.parameterLimit, s = o.split(r.delimiter, i), l = -1, c, f = r.charset;
  if (r.charsetSentinel)
    for (c = 0; c < s.length; ++c)
      s[c].indexOf("utf8=") === 0 && (s[c] === Nh ? f = "utf-8" : s[c] === Lh && (f = "iso-8859-1"), l = c, c = s.length);
  for (c = 0; c < s.length; ++c)
    if (c !== l) {
      var d = s[c], g = d.indexOf("]="), m = g === -1 ? d.indexOf("=") : g + 1, S, h;
      m === -1 ? (S = r.decoder(d, Z.decoder, f, "key"), h = r.strictNullHandling ? null : "") : (S = r.decoder(d.slice(0, m), Z.decoder, f, "key"), h = Zt.maybeMap(
        Zs(d.slice(m + 1), r),
        function(v) {
          return r.decoder(v, Z.decoder, f, "value");
        }
      )), h && r.interpretNumericEntities && f === "iso-8859-1" && (h = Fh(h)), d.indexOf("[]=") > -1 && (h = Ch(h) ? [h] : h);
      var y = _a.call(n, S);
      y && r.duplicates === "combine" ? n[S] = Zt.combine(n[S], h) : (!y || r.duplicates === "last") && (n[S] = h);
    }
  return n;
}, Dh = function(e, t, r, n) {
  for (var o = n ? t : Zs(t, r), i = e.length - 1; i >= 0; --i) {
    var s, l = e[i];
    if (l === "[]" && r.parseArrays)
      s = r.allowEmptyArrays && (o === "" || r.strictNullHandling && o === null) ? [] : [].concat(o);
    else {
      s = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var c = l.charAt(0) === "[" && l.charAt(l.length - 1) === "]" ? l.slice(1, -1) : l, f = r.decodeDotInKeys ? c.replace(/%2E/g, ".") : c, d = parseInt(f, 10);
      !r.parseArrays && f === "" ? s = { 0: o } : !isNaN(d) && l !== f && String(d) === f && d >= 0 && r.parseArrays && d <= r.arrayLimit ? (s = [], s[d] = o) : f !== "__proto__" && (s[f] = o);
    }
    o = s;
  }
  return o;
}, Bh = function(t, r, n, o) {
  if (t) {
    var i = n.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, s = /(\[[^[\]]*])/, l = /(\[[^[\]]*])/g, c = n.depth > 0 && s.exec(i), f = c ? i.slice(0, c.index) : i, d = [];
    if (f) {
      if (!n.plainObjects && _a.call(Object.prototype, f) && !n.allowPrototypes)
        return;
      d.push(f);
    }
    for (var g = 0; n.depth > 0 && (c = l.exec(i)) !== null && g < n.depth; ) {
      if (g += 1, !n.plainObjects && _a.call(Object.prototype, c[1].slice(1, -1)) && !n.allowPrototypes)
        return;
      d.push(c[1]);
    }
    if (c) {
      if (n.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + n.depth + " and strictDepth is true");
      d.push("[" + i.slice(c.index) + "]");
    }
    return Dh(d, r, n, o);
  }
}, Mh = function(t) {
  if (!t)
    return Z;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.decodeDotInKeys < "u" && typeof t.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.decoder !== null && typeof t.decoder < "u" && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = typeof t.charset > "u" ? Z.charset : t.charset, n = typeof t.duplicates > "u" ? Z.duplicates : t.duplicates;
  if (n !== "combine" && n !== "first" && n !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var o = typeof t.allowDots > "u" ? t.decodeDotInKeys === !0 ? !0 : Z.allowDots : !!t.allowDots;
  return {
    allowDots: o,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : Z.allowEmptyArrays,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : Z.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : Z.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : Z.arrayLimit,
    charset: r,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : Z.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : Z.comma,
    decodeDotInKeys: typeof t.decodeDotInKeys == "boolean" ? t.decodeDotInKeys : Z.decodeDotInKeys,
    decoder: typeof t.decoder == "function" ? t.decoder : Z.decoder,
    delimiter: typeof t.delimiter == "string" || Zt.isRegExp(t.delimiter) ? t.delimiter : Z.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : Z.depth,
    duplicates: n,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : Z.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : Z.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : Z.plainObjects,
    strictDepth: typeof t.strictDepth == "boolean" ? !!t.strictDepth : Z.strictDepth,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : Z.strictNullHandling
  };
}, jh = function(e, t) {
  var r = Mh(t);
  if (e === "" || e === null || typeof e > "u")
    return r.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var n = typeof e == "string" ? Ih(e, r) : e, o = r.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = Object.keys(n), s = 0; s < i.length; ++s) {
    var l = i[s], c = Bh(l, n[l], r, typeof e == "string");
    o = Zt.merge(o, c, r);
  }
  return r.allowSparse === !0 ? o : Zt.compact(o);
}, Uh = kh, Hh = jh, zh = Ha, Ni = {
  formats: zh,
  parse: Hh,
  stringify: Uh
}, qh = { exports: {} };
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(Ie, function() {
    var r = {};
    r.version = "0.2.0";
    var n = r.settings = {
      minimum: 0.08,
      easing: "ease",
      positionUsing: "",
      speed: 200,
      trickle: !0,
      trickleRate: 0.02,
      trickleSpeed: 800,
      showSpinner: !0,
      barSelector: '[role="bar"]',
      spinnerSelector: '[role="spinner"]',
      parent: "body",
      template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
    };
    r.configure = function(h) {
      var y, v;
      for (y in h)
        v = h[y], v !== void 0 && h.hasOwnProperty(y) && (n[y] = v);
      return this;
    }, r.status = null, r.set = function(h) {
      var y = r.isStarted();
      h = o(h, n.minimum, 1), r.status = h === 1 ? null : h;
      var v = r.render(!y), _ = v.querySelector(n.barSelector), T = n.speed, E = n.easing;
      return v.offsetWidth, l(function(O) {
        n.positionUsing === "" && (n.positionUsing = r.getPositioningCSS()), c(_, s(h, T, E)), h === 1 ? (c(v, {
          transition: "none",
          opacity: 1
        }), v.offsetWidth, setTimeout(function() {
          c(v, {
            transition: "all " + T + "ms linear",
            opacity: 0
          }), setTimeout(function() {
            r.remove(), O();
          }, T);
        }, T)) : setTimeout(O, T);
      }), this;
    }, r.isStarted = function() {
      return typeof r.status == "number";
    }, r.start = function() {
      r.status || r.set(0);
      var h = function() {
        setTimeout(function() {
          r.status && (r.trickle(), h());
        }, n.trickleSpeed);
      };
      return n.trickle && h(), this;
    }, r.done = function(h) {
      return !h && !r.status ? this : r.inc(0.3 + 0.5 * Math.random()).set(1);
    }, r.inc = function(h) {
      var y = r.status;
      return y ? (typeof h != "number" && (h = (1 - y) * o(Math.random() * y, 0.1, 0.95)), y = o(y + h, 0, 0.994), r.set(y)) : r.start();
    }, r.trickle = function() {
      return r.inc(Math.random() * n.trickleRate);
    }, function() {
      var h = 0, y = 0;
      r.promise = function(v) {
        return !v || v.state() === "resolved" ? this : (y === 0 && r.start(), h++, y++, v.always(function() {
          y--, y === 0 ? (h = 0, r.done()) : r.set((h - y) / h);
        }), this);
      };
    }(), r.render = function(h) {
      if (r.isRendered()) return document.getElementById("nprogress");
      d(document.documentElement, "nprogress-busy");
      var y = document.createElement("div");
      y.id = "nprogress", y.innerHTML = n.template;
      var v = y.querySelector(n.barSelector), _ = h ? "-100" : i(r.status || 0), T = document.querySelector(n.parent), E;
      return c(v, {
        transition: "all 0 linear",
        transform: "translate3d(" + _ + "%,0,0)"
      }), n.showSpinner || (E = y.querySelector(n.spinnerSelector), E && S(E)), T != document.body && d(T, "nprogress-custom-parent"), T.appendChild(y), y;
    }, r.remove = function() {
      g(document.documentElement, "nprogress-busy"), g(document.querySelector(n.parent), "nprogress-custom-parent");
      var h = document.getElementById("nprogress");
      h && S(h);
    }, r.isRendered = function() {
      return !!document.getElementById("nprogress");
    }, r.getPositioningCSS = function() {
      var h = document.body.style, y = "WebkitTransform" in h ? "Webkit" : "MozTransform" in h ? "Moz" : "msTransform" in h ? "ms" : "OTransform" in h ? "O" : "";
      return y + "Perspective" in h ? "translate3d" : y + "Transform" in h ? "translate" : "margin";
    };
    function o(h, y, v) {
      return h < y ? y : h > v ? v : h;
    }
    function i(h) {
      return (-1 + h) * 100;
    }
    function s(h, y, v) {
      var _;
      return n.positionUsing === "translate3d" ? _ = { transform: "translate3d(" + i(h) + "%,0,0)" } : n.positionUsing === "translate" ? _ = { transform: "translate(" + i(h) + "%,0)" } : _ = { "margin-left": i(h) + "%" }, _.transition = "all " + y + "ms " + v, _;
    }
    var l = /* @__PURE__ */ function() {
      var h = [];
      function y() {
        var v = h.shift();
        v && v(y);
      }
      return function(v) {
        h.push(v), h.length == 1 && y();
      };
    }(), c = /* @__PURE__ */ function() {
      var h = ["Webkit", "O", "Moz", "ms"], y = {};
      function v(O) {
        return O.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(P, $) {
          return $.toUpperCase();
        });
      }
      function _(O) {
        var P = document.body.style;
        if (O in P) return O;
        for (var $ = h.length, D = O.charAt(0).toUpperCase() + O.slice(1), A; $--; )
          if (A = h[$] + D, A in P) return A;
        return O;
      }
      function T(O) {
        return O = v(O), y[O] || (y[O] = _(O));
      }
      function E(O, P, $) {
        P = T(P), O.style[P] = $;
      }
      return function(O, P) {
        var $ = arguments, D, A;
        if ($.length == 2)
          for (D in P)
            A = P[D], A !== void 0 && P.hasOwnProperty(D) && E(O, D, A);
        else
          E(O, $[1], $[2]);
      };
    }();
    function f(h, y) {
      var v = typeof h == "string" ? h : m(h);
      return v.indexOf(" " + y + " ") >= 0;
    }
    function d(h, y) {
      var v = m(h), _ = v + y;
      f(v, y) || (h.className = _.substring(1));
    }
    function g(h, y) {
      var v = m(h), _;
      f(h, y) && (_ = v.replace(" " + y + " ", " "), h.className = _.substring(1, _.length - 1));
    }
    function m(h) {
      return (" " + (h.className || "") + " ").replace(/\s+/gi, " ");
    }
    function S(h) {
      h && h.parentNode && h.parentNode.removeChild(h);
    }
    return r;
  });
})(qh);
function el(e, t) {
  let r;
  return function(...n) {
    clearTimeout(r), r = setTimeout(() => e.apply(this, n), t);
  };
}
function et(e, t) {
  return document.dispatchEvent(new CustomEvent(`inertia:${e}`, t));
}
var Vh = (e) => et("before", { cancelable: !0, detail: { visit: e } }), Wh = (e) => et("error", { detail: { errors: e } }), Gh = (e) => et("exception", { cancelable: !0, detail: { exception: e } }), Ii = (e) => et("finish", { detail: { visit: e } }), Kh = (e) => et("invalid", { cancelable: !0, detail: { response: e } }), $r = (e) => et("navigate", { detail: { page: e } }), Jh = (e) => et("progress", { detail: { progress: e } }), Xh = (e) => et("start", { detail: { visit: e } }), Qh = (e) => et("success", { detail: { page: e } });
function Ta(e) {
  return e instanceof File || e instanceof Blob || e instanceof FileList && e.length > 0 || e instanceof FormData && Array.from(e.values()).some((t) => Ta(t)) || typeof e == "object" && e !== null && Object.values(e).some((t) => Ta(t));
}
function tl(e, t = new FormData(), r = null) {
  e = e || {};
  for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && nl(t, rl(r, n), e[n]);
  return t;
}
function rl(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function nl(e, t, r) {
  if (Array.isArray(r)) return Array.from(r.keys()).forEach((n) => nl(e, rl(t, n.toString()), r[n]));
  if (r instanceof Date) return e.append(t, r.toISOString());
  if (r instanceof File) return e.append(t, r, r.name);
  if (r instanceof Blob) return e.append(t, r);
  if (typeof r == "boolean") return e.append(t, r ? "1" : "0");
  if (typeof r == "string") return e.append(t, r);
  if (typeof r == "number") return e.append(t, `${r}`);
  if (r == null) return e.append(t, "");
  tl(r, e, t);
}
var Yh = { modal: null, listener: null, show(e) {
  typeof e == "object" && (e = `All Inertia requests must receive a valid Inertia response, however a plain JSON response was received.<hr>${JSON.stringify(e)}`);
  let t = document.createElement("html");
  t.innerHTML = e, t.querySelectorAll("a").forEach((n) => n.setAttribute("target", "_top")), this.modal = document.createElement("div"), this.modal.style.position = "fixed", this.modal.style.width = "100vw", this.modal.style.height = "100vh", this.modal.style.padding = "50px", this.modal.style.boxSizing = "border-box", this.modal.style.backgroundColor = "rgba(0, 0, 0, .6)", this.modal.style.zIndex = 2e5, this.modal.addEventListener("click", () => this.hide());
  let r = document.createElement("iframe");
  if (r.style.backgroundColor = "white", r.style.borderRadius = "5px", r.style.width = "100%", r.style.height = "100%", this.modal.appendChild(r), document.body.prepend(this.modal), document.body.style.overflow = "hidden", !r.contentWindow) throw new Error("iframe not yet ready.");
  r.contentWindow.document.open(), r.contentWindow.document.write(t.outerHTML), r.contentWindow.document.close(), this.listener = this.hideOnEscape.bind(this), document.addEventListener("keydown", this.listener);
}, hide() {
  this.modal.outerHTML = "", this.modal = null, document.body.style.overflow = "visible", document.removeEventListener("keydown", this.listener);
}, hideOnEscape(e) {
  e.keyCode === 27 && this.hide();
} };
function Vt(e) {
  return new URL(e.toString(), window.location.toString());
}
function ol(e, t, r, n = "brackets") {
  let o = /^https?:\/\//.test(t.toString()), i = o || t.toString().startsWith("/"), s = !i && !t.toString().startsWith("#") && !t.toString().startsWith("?"), l = t.toString().includes("?") || e === "get" && Object.keys(r).length, c = t.toString().includes("#"), f = new URL(t.toString(), "http://localhost");
  return e === "get" && Object.keys(r).length && (f.search = Ni.stringify(Ad(Ni.parse(f.search, { ignoreQueryPrefix: !0 }), r), { encodeValuesOnly: !0, arrayFormat: n }), r = {}), [[o ? `${f.protocol}//${f.host}` : "", i ? f.pathname : "", s ? f.pathname.substring(1) : "", l ? f.search : "", c ? f.hash : ""].join(""), r];
}
function Rr(e) {
  return e = new URL(e.href), e.hash = "", e;
}
var Di = typeof window > "u", Zh = class {
  constructor() {
    this.visitId = null;
  }
  init({ initialPage: e, resolveComponent: t, swapComponent: r }) {
    this.page = e, this.resolveComponent = t, this.swapComponent = r, this.setNavigationType(), this.clearRememberedStateOnReload(), this.isBackForwardVisit() ? this.handleBackForwardVisit(this.page) : this.isLocationVisit() ? this.handleLocationVisit(this.page) : this.handleInitialPageVisit(this.page), this.setupEventListeners();
  }
  setNavigationType() {
    this.navigationType = window.performance && window.performance.getEntriesByType("navigation").length > 0 ? window.performance.getEntriesByType("navigation")[0].type : "navigate";
  }
  clearRememberedStateOnReload() {
    var e;
    this.navigationType === "reload" && ((e = window.history.state) != null && e.rememberedState) && delete window.history.state.rememberedState;
  }
  handleInitialPageVisit(e) {
    this.page.url += window.location.hash, this.setPage(e, { preserveState: !0 }).then(() => $r(e));
  }
  setupEventListeners() {
    window.addEventListener("popstate", this.handlePopstateEvent.bind(this)), document.addEventListener("scroll", el(this.handleScrollEvent.bind(this), 100), !0);
  }
  scrollRegions() {
    return document.querySelectorAll("[scroll-region]");
  }
  handleScrollEvent(e) {
    typeof e.target.hasAttribute == "function" && e.target.hasAttribute("scroll-region") && this.saveScrollPositions();
  }
  saveScrollPositions() {
    this.replaceState({ ...this.page, scrollRegions: Array.from(this.scrollRegions()).map((e) => ({ top: e.scrollTop, left: e.scrollLeft })) });
  }
  resetScrollPositions() {
    window.scrollTo(0, 0), this.scrollRegions().forEach((e) => {
      typeof e.scrollTo == "function" ? e.scrollTo(0, 0) : (e.scrollTop = 0, e.scrollLeft = 0);
    }), this.saveScrollPositions(), window.location.hash && setTimeout(() => {
      var e;
      return (e = document.getElementById(window.location.hash.slice(1))) == null ? void 0 : e.scrollIntoView();
    });
  }
  restoreScrollPositions() {
    this.page.scrollRegions && this.scrollRegions().forEach((e, t) => {
      let r = this.page.scrollRegions[t];
      if (r) typeof e.scrollTo == "function" ? e.scrollTo(r.left, r.top) : (e.scrollTop = r.top, e.scrollLeft = r.left);
      else return;
    });
  }
  isBackForwardVisit() {
    return window.history.state && this.navigationType === "back_forward";
  }
  handleBackForwardVisit(e) {
    window.history.state.version = e.version, this.setPage(window.history.state, { preserveScroll: !0, preserveState: !0 }).then(() => {
      this.restoreScrollPositions(), $r(e);
    });
  }
  locationVisit(e, t) {
    try {
      let r = { preserveScroll: t };
      window.sessionStorage.setItem("inertiaLocationVisit", JSON.stringify(r)), window.location.href = e.href, Rr(window.location).href === Rr(e).href && window.location.reload();
    } catch {
      return !1;
    }
  }
  isLocationVisit() {
    try {
      return window.sessionStorage.getItem("inertiaLocationVisit") !== null;
    } catch {
      return !1;
    }
  }
  handleLocationVisit(e) {
    var r, n;
    let t = JSON.parse(window.sessionStorage.getItem("inertiaLocationVisit") || "");
    window.sessionStorage.removeItem("inertiaLocationVisit"), e.url += window.location.hash, e.rememberedState = ((r = window.history.state) == null ? void 0 : r.rememberedState) ?? {}, e.scrollRegions = ((n = window.history.state) == null ? void 0 : n.scrollRegions) ?? [], this.setPage(e, { preserveScroll: t.preserveScroll, preserveState: !0 }).then(() => {
      t.preserveScroll && this.restoreScrollPositions(), $r(e);
    });
  }
  isLocationVisitResponse(e) {
    return !!(e && e.status === 409 && e.headers["x-inertia-location"]);
  }
  isInertiaResponse(e) {
    return !!(e != null && e.headers["x-inertia"]);
  }
  createVisitId() {
    return this.visitId = {}, this.visitId;
  }
  cancelVisit(e, { cancelled: t = !1, interrupted: r = !1 }) {
    e && !e.completed && !e.cancelled && !e.interrupted && (e.cancelToken.abort(), e.onCancel(), e.completed = !1, e.cancelled = t, e.interrupted = r, Ii(e), e.onFinish(e));
  }
  finishVisit(e) {
    !e.cancelled && !e.interrupted && (e.completed = !0, e.cancelled = !1, e.interrupted = !1, Ii(e), e.onFinish(e));
  }
  resolvePreserveOption(e, t) {
    return typeof e == "function" ? e(t) : e === "errors" ? Object.keys(t.props.errors || {}).length > 0 : e;
  }
  cancel() {
    this.activeVisit && this.cancelVisit(this.activeVisit, { cancelled: !0 });
  }
  visit(e, { method: t = "get", data: r = {}, replace: n = !1, preserveScroll: o = !1, preserveState: i = !1, only: s = [], except: l = [], headers: c = {}, errorBag: f = "", forceFormData: d = !1, onCancelToken: g = () => {
  }, onBefore: m = () => {
  }, onStart: S = () => {
  }, onProgress: h = () => {
  }, onFinish: y = () => {
  }, onCancel: v = () => {
  }, onSuccess: _ = () => {
  }, onError: T = () => {
  }, queryStringArrayFormat: E = "brackets" } = {}) {
    let O = typeof e == "string" ? Vt(e) : e;
    if ((Ta(r) || d) && !(r instanceof FormData) && (r = tl(r)), !(r instanceof FormData)) {
      let [A, k] = ol(t, O, r, E);
      O = Vt(A), r = k;
    }
    let P = { url: O, method: t, data: r, replace: n, preserveScroll: o, preserveState: i, only: s, except: l, headers: c, errorBag: f, forceFormData: d, queryStringArrayFormat: E, cancelled: !1, completed: !1, interrupted: !1 };
    if (m(P) === !1 || !Vh(P)) return;
    this.activeVisit && this.cancelVisit(this.activeVisit, { interrupted: !0 }), this.saveScrollPositions();
    let $ = this.createVisitId();
    this.activeVisit = { ...P, onCancelToken: g, onBefore: m, onStart: S, onProgress: h, onFinish: y, onCancel: v, onSuccess: _, onError: T, queryStringArrayFormat: E, cancelToken: new AbortController() }, g({ cancel: () => {
      this.activeVisit && this.cancelVisit(this.activeVisit, { cancelled: !0 });
    } }), Xh(P), S(P);
    let D = !!(s.length || l.length);
    re({ method: t, url: Rr(O).href, data: t === "get" ? {} : r, params: t === "get" ? r : {}, signal: this.activeVisit.cancelToken.signal, headers: { ...c, Accept: "text/html, application/xhtml+xml", "X-Requested-With": "XMLHttpRequest", "X-Inertia": !0, ...D ? { "X-Inertia-Partial-Component": this.page.component } : {}, ...s.length ? { "X-Inertia-Partial-Data": s.join(",") } : {}, ...l.length ? { "X-Inertia-Partial-Except": l.join(",") } : {}, ...f && f.length ? { "X-Inertia-Error-Bag": f } : {}, ...this.page.version ? { "X-Inertia-Version": this.page.version } : {} }, onUploadProgress: (A) => {
      r instanceof FormData && (A.percentage = A.progress ? Math.round(A.progress * 100) : 0, Jh(A), h(A));
    } }).then((A) => {
      var te;
      if (!this.isInertiaResponse(A)) return Promise.reject({ response: A });
      let k = A.data;
      D && k.component === this.page.component && (k.props = { ...this.page.props, ...k.props }), o = this.resolvePreserveOption(o, k), i = this.resolvePreserveOption(i, k), i && ((te = window.history.state) != null && te.rememberedState) && k.component === this.page.component && (k.rememberedState = window.history.state.rememberedState);
      let W = O, ae = Vt(k.url);
      return W.hash && !ae.hash && Rr(W).href === ae.href && (ae.hash = W.hash, k.url = ae.href), this.setPage(k, { visitId: $, replace: n, preserveScroll: o, preserveState: i });
    }).then(() => {
      let A = this.page.props.errors || {};
      if (Object.keys(A).length > 0) {
        let k = f ? A[f] ? A[f] : {} : A;
        return Wh(k), T(k);
      }
      return Qh(this.page), _(this.page);
    }).catch((A) => {
      if (this.isInertiaResponse(A.response)) return this.setPage(A.response.data, { visitId: $ });
      if (this.isLocationVisitResponse(A.response)) {
        let k = Vt(A.response.headers["x-inertia-location"]), W = O;
        W.hash && !k.hash && Rr(W).href === k.href && (k.hash = W.hash), this.locationVisit(k, o === !0);
      } else if (A.response) Kh(A.response) && Yh.show(A.response.data);
      else return Promise.reject(A);
    }).then(() => {
      this.activeVisit && this.finishVisit(this.activeVisit);
    }).catch((A) => {
      if (!re.isCancel(A)) {
        let k = Gh(A);
        if (this.activeVisit && this.finishVisit(this.activeVisit), k) return Promise.reject(A);
      }
    });
  }
  setPage(e, { visitId: t = this.createVisitId(), replace: r = !1, preserveScroll: n = !1, preserveState: o = !1 } = {}) {
    return Promise.resolve(this.resolveComponent(e.component)).then((i) => {
      t === this.visitId && (e.scrollRegions = e.scrollRegions || [], e.rememberedState = e.rememberedState || {}, r = r || Vt(e.url).href === window.location.href, r ? this.replaceState(e) : this.pushState(e), this.swapComponent({ component: i, page: e, preserveState: o }).then(() => {
        n || this.resetScrollPositions(), r || $r(e);
      }));
    });
  }
  pushState(e) {
    this.page = e, window.history.pushState(e, "", e.url);
  }
  replaceState(e) {
    this.page = e, window.history.replaceState(e, "", e.url);
  }
  handlePopstateEvent(e) {
    if (e.state !== null) {
      let t = e.state, r = this.createVisitId();
      Promise.resolve(this.resolveComponent(t.component)).then((n) => {
        r === this.visitId && (this.page = t, this.swapComponent({ component: n, page: t, preserveState: !1 }).then(() => {
          this.restoreScrollPositions(), $r(t);
        }));
      });
    } else {
      let t = Vt(this.page.url);
      t.hash = window.location.hash, this.replaceState({ ...this.page, url: t.href }), this.resetScrollPositions();
    }
  }
  get(e, t = {}, r = {}) {
    return this.visit(e, { ...r, method: "get", data: t });
  }
  reload(e = {}) {
    return this.visit(window.location.href, { ...e, preserveScroll: !0, preserveState: !0 });
  }
  replace(e, t = {}) {
    return console.warn(`Inertia.replace() has been deprecated and will be removed in a future release. Please use Inertia.${t.method ?? "get"}() instead.`), this.visit(e, { preserveState: !0, ...t, replace: !0 });
  }
  post(e, t = {}, r = {}) {
    return this.visit(e, { preserveState: !0, ...r, method: "post", data: t });
  }
  put(e, t = {}, r = {}) {
    return this.visit(e, { preserveState: !0, ...r, method: "put", data: t });
  }
  patch(e, t = {}, r = {}) {
    return this.visit(e, { preserveState: !0, ...r, method: "patch", data: t });
  }
  delete(e, t = {}) {
    return this.visit(e, { preserveState: !0, ...t, method: "delete" });
  }
  remember(e, t = "default") {
    var r;
    Di || this.replaceState({ ...this.page, rememberedState: { ...(r = this.page) == null ? void 0 : r.rememberedState, [t]: e } });
  }
  restore(e = "default") {
    var t, r;
    if (!Di) return (r = (t = window.history.state) == null ? void 0 : t.rememberedState) == null ? void 0 : r[e];
  }
  on(e, t) {
    let r = (n) => {
      let o = t(n);
      n.cancelable && !n.defaultPrevented && o === !1 && n.preventDefault();
    };
    return document.addEventListener(`inertia:${e}`, r), () => document.removeEventListener(`inertia:${e}`, r);
  }
}, ey = { buildDOMElement(e) {
  let t = document.createElement("template");
  t.innerHTML = e;
  let r = t.content.firstChild;
  if (!e.startsWith("<script ")) return r;
  let n = document.createElement("script");
  return n.innerHTML = r.innerHTML, r.getAttributeNames().forEach((o) => {
    n.setAttribute(o, r.getAttribute(o) || "");
  }), n;
}, isInertiaManagedElement(e) {
  return e.nodeType === Node.ELEMENT_NODE && e.getAttribute("inertia") !== null;
}, findMatchingElementIndex(e, t) {
  let r = e.getAttribute("inertia");
  return r !== null ? t.findIndex((n) => n.getAttribute("inertia") === r) : -1;
}, update: el(function(e) {
  let t = e.map((r) => this.buildDOMElement(r));
  Array.from(document.head.childNodes).filter((r) => this.isInertiaManagedElement(r)).forEach((r) => {
    var i, s;
    let n = this.findMatchingElementIndex(r, t);
    if (n === -1) {
      (i = r == null ? void 0 : r.parentNode) == null || i.removeChild(r);
      return;
    }
    let o = t.splice(n, 1)[0];
    o && !r.isEqualNode(o) && ((s = r == null ? void 0 : r.parentNode) == null || s.replaceChild(o, r));
  }), t.forEach((r) => document.head.appendChild(r));
}, 1) };
function ty(e, t, r) {
  let n = {}, o = 0;
  function i() {
    let d = o += 1;
    return n[d] = [], d.toString();
  }
  function s(d) {
    d === null || Object.keys(n).indexOf(d) === -1 || (delete n[d], f());
  }
  function l(d, g = []) {
    d !== null && Object.keys(n).indexOf(d) > -1 && (n[d] = g), f();
  }
  function c() {
    let d = t(""), g = { ...d ? { title: `<title inertia="">${d}</title>` } : {} }, m = Object.values(n).reduce((S, h) => S.concat(h), []).reduce((S, h) => {
      if (h.indexOf("<") === -1) return S;
      if (h.indexOf("<title ") === 0) {
        let v = h.match(/(<title [^>]+>)(.*?)(<\/title>)/);
        return S.title = v ? `${v[1]}${t(v[2])}${v[3]}` : h, S;
      }
      let y = h.match(/ inertia="[^"]+"/);
      return y ? S[y[0]] = h : S[Object.keys(S).length] = h, S;
    }, g);
    return Object.values(m);
  }
  function f() {
    e ? r(c()) : ey.update(c());
  }
  return f(), { forceUpdate: f, createProvider: function() {
    let d = i();
    return { update: (g) => l(d, g), disconnect: () => s(d) };
  } };
}
function ry(e) {
  let t = e.currentTarget.tagName.toLowerCase() === "a";
  return !(e.target && (e == null ? void 0 : e.target).isContentEditable || e.defaultPrevented || t && e.which > 1 || t && e.altKey || t && e.ctrlKey || t && e.metaKey || t && e.shiftKey);
}
var Oa = new Zh(), Dn = { exports: {} };
Dn.exports;
(function(e, t) {
  var r = 200, n = "__lodash_hash_undefined__", o = 9007199254740991, i = "[object Arguments]", s = "[object Array]", l = "[object Boolean]", c = "[object Date]", f = "[object Error]", d = "[object Function]", g = "[object GeneratorFunction]", m = "[object Map]", S = "[object Number]", h = "[object Object]", y = "[object Promise]", v = "[object RegExp]", _ = "[object Set]", T = "[object String]", E = "[object Symbol]", O = "[object WeakMap]", P = "[object ArrayBuffer]", $ = "[object DataView]", D = "[object Float32Array]", A = "[object Float64Array]", k = "[object Int8Array]", W = "[object Int16Array]", ae = "[object Int32Array]", te = "[object Uint8Array]", K = "[object Uint8ClampedArray]", ie = "[object Uint16Array]", Q = "[object Uint32Array]", se = /[\\^$.*+?()[\]{}|]/g, we = /\w*$/, tt = /^\[object .+?Constructor\]$/, Ke = /^(?:0|[1-9]\d*)$/, B = {};
  B[i] = B[s] = B[P] = B[$] = B[l] = B[c] = B[D] = B[A] = B[k] = B[W] = B[ae] = B[m] = B[S] = B[h] = B[v] = B[_] = B[T] = B[E] = B[te] = B[K] = B[ie] = B[Q] = !0, B[f] = B[d] = B[O] = !1;
  var q = typeof Ie == "object" && Ie && Ie.Object === Object && Ie, J = typeof self == "object" && self && self.Object === Object && self, X = q || J || Function("return this")(), fe = t && !t.nodeType && t, H = fe && !0 && e && !e.nodeType && e, Je = H && H.exports === fe;
  function Vn(a, u) {
    return a.set(u[0], u[1]), a;
  }
  function Fe(a, u) {
    return a.add(u), a;
  }
  function Vr(a, u) {
    for (var p = -1, w = a ? a.length : 0; ++p < w && u(a[p], p, a) !== !1; )
      ;
    return a;
  }
  function Wr(a, u) {
    for (var p = -1, w = u.length, R = a.length; ++p < w; )
      a[R + p] = u[p];
    return a;
  }
  function ir(a, u, p, w) {
    for (var R = -1, x = a ? a.length : 0; ++R < x; )
      p = u(p, a[R], R, a);
    return p;
  }
  function sr(a, u) {
    for (var p = -1, w = Array(a); ++p < a; )
      w[p] = u(p);
    return w;
  }
  function Gr(a, u) {
    return a == null ? void 0 : a[u];
  }
  function lr(a) {
    var u = !1;
    if (a != null && typeof a.toString != "function")
      try {
        u = !!(a + "");
      } catch {
      }
    return u;
  }
  function Kr(a) {
    var u = -1, p = Array(a.size);
    return a.forEach(function(w, R) {
      p[++u] = [R, w];
    }), p;
  }
  function ur(a, u) {
    return function(p) {
      return a(u(p));
    };
  }
  function Jr(a) {
    var u = -1, p = Array(a.size);
    return a.forEach(function(w) {
      p[++u] = w;
    }), p;
  }
  var Wn = Array.prototype, Gn = Function.prototype, Ct = Object.prototype, cr = X["__core-js_shared__"], Xr = function() {
    var a = /[^.]+$/.exec(cr && cr.keys && cr.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }(), Qr = Gn.toString, je = Ct.hasOwnProperty, Ft = Ct.toString, Kn = RegExp(
    "^" + Qr.call(je).replace(se, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ft = Je ? X.Buffer : void 0, Lt = X.Symbol, fr = X.Uint8Array, Re = ur(Object.getPrototypeOf, Object), Yr = Object.create, Zr = Ct.propertyIsEnumerable, Jn = Wn.splice, dr = Object.getOwnPropertySymbols, Nt = ft ? ft.isBuffer : void 0, en = ur(Object.keys, Object), It = Ne(X, "DataView"), dt = Ne(X, "Map"), Le = Ne(X, "Promise"), Dt = Ne(X, "Set"), pr = Ne(X, "WeakMap"), pt = Ne(Object, "create"), hr = be(It), ht = be(dt), yr = be(Le), mr = be(Dt), gr = be(pr), rt = Lt ? Lt.prototype : void 0, tn = rt ? rt.valueOf : void 0;
  function Xe(a) {
    var u = -1, p = a ? a.length : 0;
    for (this.clear(); ++u < p; ) {
      var w = a[u];
      this.set(w[0], w[1]);
    }
  }
  function Xn() {
    this.__data__ = pt ? pt(null) : {};
  }
  function Qn(a) {
    return this.has(a) && delete this.__data__[a];
  }
  function Yn(a) {
    var u = this.__data__;
    if (pt) {
      var p = u[a];
      return p === n ? void 0 : p;
    }
    return je.call(u, a) ? u[a] : void 0;
  }
  function rn(a) {
    var u = this.__data__;
    return pt ? u[a] !== void 0 : je.call(u, a);
  }
  function vr(a, u) {
    var p = this.__data__;
    return p[a] = pt && u === void 0 ? n : u, this;
  }
  Xe.prototype.clear = Xn, Xe.prototype.delete = Qn, Xe.prototype.get = Yn, Xe.prototype.has = rn, Xe.prototype.set = vr;
  function de(a) {
    var u = -1, p = a ? a.length : 0;
    for (this.clear(); ++u < p; ) {
      var w = a[u];
      this.set(w[0], w[1]);
    }
  }
  function Zn() {
    this.__data__ = [];
  }
  function eo(a) {
    var u = this.__data__, p = Mt(u, a);
    if (p < 0)
      return !1;
    var w = u.length - 1;
    return p == w ? u.pop() : Jn.call(u, p, 1), !0;
  }
  function to(a) {
    var u = this.__data__, p = Mt(u, a);
    return p < 0 ? void 0 : u[p][1];
  }
  function ro(a) {
    return Mt(this.__data__, a) > -1;
  }
  function no(a, u) {
    var p = this.__data__, w = Mt(p, a);
    return w < 0 ? p.push([a, u]) : p[w][1] = u, this;
  }
  de.prototype.clear = Zn, de.prototype.delete = eo, de.prototype.get = to, de.prototype.has = ro, de.prototype.set = no;
  function he(a) {
    var u = -1, p = a ? a.length : 0;
    for (this.clear(); ++u < p; ) {
      var w = a[u];
      this.set(w[0], w[1]);
    }
  }
  function oo() {
    this.__data__ = {
      hash: new Xe(),
      map: new (dt || de)(),
      string: new Xe()
    };
  }
  function ao(a) {
    return mt(this, a).delete(a);
  }
  function io(a) {
    return mt(this, a).get(a);
  }
  function so(a) {
    return mt(this, a).has(a);
  }
  function lo(a, u) {
    return mt(this, a).set(a, u), this;
  }
  he.prototype.clear = oo, he.prototype.delete = ao, he.prototype.get = io, he.prototype.has = so, he.prototype.set = lo;
  function Se(a) {
    this.__data__ = new de(a);
  }
  function uo() {
    this.__data__ = new de();
  }
  function co(a) {
    return this.__data__.delete(a);
  }
  function fo(a) {
    return this.__data__.get(a);
  }
  function po(a) {
    return this.__data__.has(a);
  }
  function ho(a, u) {
    var p = this.__data__;
    if (p instanceof de) {
      var w = p.__data__;
      if (!dt || w.length < r - 1)
        return w.push([a, u]), this;
      p = this.__data__ = new he(w);
    }
    return p.set(a, u), this;
  }
  Se.prototype.clear = uo, Se.prototype.delete = co, Se.prototype.get = fo, Se.prototype.has = po, Se.prototype.set = ho;
  function Bt(a, u) {
    var p = Er(a) || Ut(a) ? sr(a.length, String) : [], w = p.length, R = !!w;
    for (var x in a)
      je.call(a, x) && !(R && (x == "length" || Po(x, w))) && p.push(x);
    return p;
  }
  function nn(a, u, p) {
    var w = a[u];
    (!(je.call(a, u) && un(w, p)) || p === void 0 && !(u in a)) && (a[u] = p);
  }
  function Mt(a, u) {
    for (var p = a.length; p--; )
      if (un(a[p][0], u))
        return p;
    return -1;
  }
  function Ue(a, u) {
    return a && Sr(u, Tr(u), a);
  }
  function br(a, u, p, w, R, x, z) {
    var j;
    if (w && (j = x ? w(a, R, x, z) : w(a)), j !== void 0)
      return j;
    if (!ze(a))
      return a;
    var ne = Er(a);
    if (ne) {
      if (j = Ao(a), !u)
        return _o(a, j);
    } else {
      var V = Ye(a), ye = V == d || V == g;
      if (cn(a))
        return jt(a, u);
      if (V == h || V == i || ye && !x) {
        if (lr(a))
          return x ? a : {};
        if (j = He(ye ? {} : a), !u)
          return To(a, Ue(j, a));
      } else {
        if (!B[V])
          return x ? a : {};
        j = xo(a, V, br, u);
      }
    }
    z || (z = new Se());
    var Ee = z.get(a);
    if (Ee)
      return Ee;
    if (z.set(a, j), !ne)
      var le = p ? Oo(a) : Tr(a);
    return Vr(le || a, function(me, pe) {
      le && (pe = me, me = a[pe]), nn(j, pe, br(me, u, p, w, pe, a, z));
    }), j;
  }
  function yo(a) {
    return ze(a) ? Yr(a) : {};
  }
  function mo(a, u, p) {
    var w = u(a);
    return Er(a) ? w : Wr(w, p(a));
  }
  function go(a) {
    return Ft.call(a);
  }
  function vo(a) {
    if (!ze(a) || Ro(a))
      return !1;
    var u = _r(a) || lr(a) ? Kn : tt;
    return u.test(be(a));
  }
  function bo(a) {
    if (!sn(a))
      return en(a);
    var u = [];
    for (var p in Object(a))
      je.call(a, p) && p != "constructor" && u.push(p);
    return u;
  }
  function jt(a, u) {
    if (u)
      return a.slice();
    var p = new a.constructor(a.length);
    return a.copy(p), p;
  }
  function wr(a) {
    var u = new a.constructor(a.byteLength);
    return new fr(u).set(new fr(a)), u;
  }
  function yt(a, u) {
    var p = u ? wr(a.buffer) : a.buffer;
    return new a.constructor(p, a.byteOffset, a.byteLength);
  }
  function on(a, u, p) {
    var w = u ? p(Kr(a), !0) : Kr(a);
    return ir(w, Vn, new a.constructor());
  }
  function an(a) {
    var u = new a.constructor(a.source, we.exec(a));
    return u.lastIndex = a.lastIndex, u;
  }
  function wo(a, u, p) {
    var w = u ? p(Jr(a), !0) : Jr(a);
    return ir(w, Fe, new a.constructor());
  }
  function So(a) {
    return tn ? Object(tn.call(a)) : {};
  }
  function Eo(a, u) {
    var p = u ? wr(a.buffer) : a.buffer;
    return new a.constructor(p, a.byteOffset, a.length);
  }
  function _o(a, u) {
    var p = -1, w = a.length;
    for (u || (u = Array(w)); ++p < w; )
      u[p] = a[p];
    return u;
  }
  function Sr(a, u, p, w) {
    p || (p = {});
    for (var R = -1, x = u.length; ++R < x; ) {
      var z = u[R], j = void 0;
      nn(p, z, j === void 0 ? a[z] : j);
    }
    return p;
  }
  function To(a, u) {
    return Sr(a, Qe(a), u);
  }
  function Oo(a) {
    return mo(a, Tr, Qe);
  }
  function mt(a, u) {
    var p = a.__data__;
    return $o(u) ? p[typeof u == "string" ? "string" : "hash"] : p.map;
  }
  function Ne(a, u) {
    var p = Gr(a, u);
    return vo(p) ? p : void 0;
  }
  var Qe = dr ? ur(dr, Object) : Co, Ye = go;
  (It && Ye(new It(new ArrayBuffer(1))) != $ || dt && Ye(new dt()) != m || Le && Ye(Le.resolve()) != y || Dt && Ye(new Dt()) != _ || pr && Ye(new pr()) != O) && (Ye = function(a) {
    var u = Ft.call(a), p = u == h ? a.constructor : void 0, w = p ? be(p) : void 0;
    if (w)
      switch (w) {
        case hr:
          return $;
        case ht:
          return m;
        case yr:
          return y;
        case mr:
          return _;
        case gr:
          return O;
      }
    return u;
  });
  function Ao(a) {
    var u = a.length, p = a.constructor(u);
    return u && typeof a[0] == "string" && je.call(a, "index") && (p.index = a.index, p.input = a.input), p;
  }
  function He(a) {
    return typeof a.constructor == "function" && !sn(a) ? yo(Re(a)) : {};
  }
  function xo(a, u, p, w) {
    var R = a.constructor;
    switch (u) {
      case P:
        return wr(a);
      case l:
      case c:
        return new R(+a);
      case $:
        return yt(a, w);
      case D:
      case A:
      case k:
      case W:
      case ae:
      case te:
      case K:
      case ie:
      case Q:
        return Eo(a, w);
      case m:
        return on(a, w, p);
      case S:
      case T:
        return new R(a);
      case v:
        return an(a);
      case _:
        return wo(a, w, p);
      case E:
        return So(a);
    }
  }
  function Po(a, u) {
    return u = u ?? o, !!u && (typeof a == "number" || Ke.test(a)) && a > -1 && a % 1 == 0 && a < u;
  }
  function $o(a) {
    var u = typeof a;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? a !== "__proto__" : a === null;
  }
  function Ro(a) {
    return !!Xr && Xr in a;
  }
  function sn(a) {
    var u = a && a.constructor, p = typeof u == "function" && u.prototype || Ct;
    return a === p;
  }
  function be(a) {
    if (a != null) {
      try {
        return Qr.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  function ln(a) {
    return br(a, !0, !0);
  }
  function un(a, u) {
    return a === u || a !== a && u !== u;
  }
  function Ut(a) {
    return ko(a) && je.call(a, "callee") && (!Zr.call(a, "callee") || Ft.call(a) == i);
  }
  var Er = Array.isArray;
  function Ht(a) {
    return a != null && fn(a.length) && !_r(a);
  }
  function ko(a) {
    return dn(a) && Ht(a);
  }
  var cn = Nt || Fo;
  function _r(a) {
    var u = ze(a) ? Ft.call(a) : "";
    return u == d || u == g;
  }
  function fn(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= o;
  }
  function ze(a) {
    var u = typeof a;
    return !!a && (u == "object" || u == "function");
  }
  function dn(a) {
    return !!a && typeof a == "object";
  }
  function Tr(a) {
    return Ht(a) ? Bt(a) : bo(a);
  }
  function Co() {
    return [];
  }
  function Fo() {
    return !1;
  }
  e.exports = ln;
})(Dn, Dn.exports);
Dn.exports;
var Bn = { exports: {} };
Bn.exports;
(function(e, t) {
  var r = 200, n = "__lodash_hash_undefined__", o = 1, i = 2, s = 9007199254740991, l = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", d = "[object Boolean]", g = "[object Date]", m = "[object Error]", S = "[object Function]", h = "[object GeneratorFunction]", y = "[object Map]", v = "[object Number]", _ = "[object Null]", T = "[object Object]", E = "[object Promise]", O = "[object Proxy]", P = "[object RegExp]", $ = "[object Set]", D = "[object String]", A = "[object Symbol]", k = "[object Undefined]", W = "[object WeakMap]", ae = "[object ArrayBuffer]", te = "[object DataView]", K = "[object Float32Array]", ie = "[object Float64Array]", Q = "[object Int8Array]", se = "[object Int16Array]", we = "[object Int32Array]", tt = "[object Uint8Array]", Ke = "[object Uint8ClampedArray]", B = "[object Uint16Array]", q = "[object Uint32Array]", J = /[\\^$.*+?()[\]{}|]/g, X = /^\[object .+?Constructor\]$/, fe = /^(?:0|[1-9]\d*)$/, H = {};
  H[K] = H[ie] = H[Q] = H[se] = H[we] = H[tt] = H[Ke] = H[B] = H[q] = !0, H[l] = H[c] = H[ae] = H[d] = H[te] = H[g] = H[m] = H[S] = H[y] = H[v] = H[T] = H[P] = H[$] = H[D] = H[W] = !1;
  var Je = typeof Ie == "object" && Ie && Ie.Object === Object && Ie, Vn = typeof self == "object" && self && self.Object === Object && self, Fe = Je || Vn || Function("return this")(), Vr = t && !t.nodeType && t, Wr = Vr && !0 && e && !e.nodeType && e, ir = Wr && Wr.exports === Vr, sr = ir && Je.process, Gr = function() {
    try {
      return sr && sr.binding && sr.binding("util");
    } catch {
    }
  }(), lr = Gr && Gr.isTypedArray;
  function Kr(a, u) {
    for (var p = -1, w = a == null ? 0 : a.length, R = 0, x = []; ++p < w; ) {
      var z = a[p];
      u(z, p, a) && (x[R++] = z);
    }
    return x;
  }
  function ur(a, u) {
    for (var p = -1, w = u.length, R = a.length; ++p < w; )
      a[R + p] = u[p];
    return a;
  }
  function Jr(a, u) {
    for (var p = -1, w = a == null ? 0 : a.length; ++p < w; )
      if (u(a[p], p, a))
        return !0;
    return !1;
  }
  function Wn(a, u) {
    for (var p = -1, w = Array(a); ++p < a; )
      w[p] = u(p);
    return w;
  }
  function Gn(a) {
    return function(u) {
      return a(u);
    };
  }
  function Ct(a, u) {
    return a.has(u);
  }
  function cr(a, u) {
    return a == null ? void 0 : a[u];
  }
  function Xr(a) {
    var u = -1, p = Array(a.size);
    return a.forEach(function(w, R) {
      p[++u] = [R, w];
    }), p;
  }
  function Qr(a, u) {
    return function(p) {
      return a(u(p));
    };
  }
  function je(a) {
    var u = -1, p = Array(a.size);
    return a.forEach(function(w) {
      p[++u] = w;
    }), p;
  }
  var Ft = Array.prototype, Kn = Function.prototype, ft = Object.prototype, Lt = Fe["__core-js_shared__"], fr = Kn.toString, Re = ft.hasOwnProperty, Yr = function() {
    var a = /[^.]+$/.exec(Lt && Lt.keys && Lt.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }(), Zr = ft.toString, Jn = RegExp(
    "^" + fr.call(Re).replace(J, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), dr = ir ? Fe.Buffer : void 0, Nt = Fe.Symbol, en = Fe.Uint8Array, It = ft.propertyIsEnumerable, dt = Ft.splice, Le = Nt ? Nt.toStringTag : void 0, Dt = Object.getOwnPropertySymbols, pr = dr ? dr.isBuffer : void 0, pt = Qr(Object.keys, Object), hr = Qe(Fe, "DataView"), ht = Qe(Fe, "Map"), yr = Qe(Fe, "Promise"), mr = Qe(Fe, "Set"), gr = Qe(Fe, "WeakMap"), rt = Qe(Object, "create"), tn = be(hr), Xe = be(ht), Xn = be(yr), Qn = be(mr), Yn = be(gr), rn = Nt ? Nt.prototype : void 0, vr = rn ? rn.valueOf : void 0;
  function de(a) {
    var u = -1, p = a == null ? 0 : a.length;
    for (this.clear(); ++u < p; ) {
      var w = a[u];
      this.set(w[0], w[1]);
    }
  }
  function Zn() {
    this.__data__ = rt ? rt(null) : {}, this.size = 0;
  }
  function eo(a) {
    var u = this.has(a) && delete this.__data__[a];
    return this.size -= u ? 1 : 0, u;
  }
  function to(a) {
    var u = this.__data__;
    if (rt) {
      var p = u[a];
      return p === n ? void 0 : p;
    }
    return Re.call(u, a) ? u[a] : void 0;
  }
  function ro(a) {
    var u = this.__data__;
    return rt ? u[a] !== void 0 : Re.call(u, a);
  }
  function no(a, u) {
    var p = this.__data__;
    return this.size += this.has(a) ? 0 : 1, p[a] = rt && u === void 0 ? n : u, this;
  }
  de.prototype.clear = Zn, de.prototype.delete = eo, de.prototype.get = to, de.prototype.has = ro, de.prototype.set = no;
  function he(a) {
    var u = -1, p = a == null ? 0 : a.length;
    for (this.clear(); ++u < p; ) {
      var w = a[u];
      this.set(w[0], w[1]);
    }
  }
  function oo() {
    this.__data__ = [], this.size = 0;
  }
  function ao(a) {
    var u = this.__data__, p = jt(u, a);
    if (p < 0)
      return !1;
    var w = u.length - 1;
    return p == w ? u.pop() : dt.call(u, p, 1), --this.size, !0;
  }
  function io(a) {
    var u = this.__data__, p = jt(u, a);
    return p < 0 ? void 0 : u[p][1];
  }
  function so(a) {
    return jt(this.__data__, a) > -1;
  }
  function lo(a, u) {
    var p = this.__data__, w = jt(p, a);
    return w < 0 ? (++this.size, p.push([a, u])) : p[w][1] = u, this;
  }
  he.prototype.clear = oo, he.prototype.delete = ao, he.prototype.get = io, he.prototype.has = so, he.prototype.set = lo;
  function Se(a) {
    var u = -1, p = a == null ? 0 : a.length;
    for (this.clear(); ++u < p; ) {
      var w = a[u];
      this.set(w[0], w[1]);
    }
  }
  function uo() {
    this.size = 0, this.__data__ = {
      hash: new de(),
      map: new (ht || he)(),
      string: new de()
    };
  }
  function co(a) {
    var u = Ne(this, a).delete(a);
    return this.size -= u ? 1 : 0, u;
  }
  function fo(a) {
    return Ne(this, a).get(a);
  }
  function po(a) {
    return Ne(this, a).has(a);
  }
  function ho(a, u) {
    var p = Ne(this, a), w = p.size;
    return p.set(a, u), this.size += p.size == w ? 0 : 1, this;
  }
  Se.prototype.clear = uo, Se.prototype.delete = co, Se.prototype.get = fo, Se.prototype.has = po, Se.prototype.set = ho;
  function Bt(a) {
    var u = -1, p = a == null ? 0 : a.length;
    for (this.__data__ = new Se(); ++u < p; )
      this.add(a[u]);
  }
  function nn(a) {
    return this.__data__.set(a, n), this;
  }
  function Mt(a) {
    return this.__data__.has(a);
  }
  Bt.prototype.add = Bt.prototype.push = nn, Bt.prototype.has = Mt;
  function Ue(a) {
    var u = this.__data__ = new he(a);
    this.size = u.size;
  }
  function br() {
    this.__data__ = new he(), this.size = 0;
  }
  function yo(a) {
    var u = this.__data__, p = u.delete(a);
    return this.size = u.size, p;
  }
  function mo(a) {
    return this.__data__.get(a);
  }
  function go(a) {
    return this.__data__.has(a);
  }
  function vo(a, u) {
    var p = this.__data__;
    if (p instanceof he) {
      var w = p.__data__;
      if (!ht || w.length < r - 1)
        return w.push([a, u]), this.size = ++p.size, this;
      p = this.__data__ = new Se(w);
    }
    return p.set(a, u), this.size = p.size, this;
  }
  Ue.prototype.clear = br, Ue.prototype.delete = yo, Ue.prototype.get = mo, Ue.prototype.has = go, Ue.prototype.set = vo;
  function bo(a, u) {
    var p = Ut(a), w = !p && un(a), R = !p && !w && Ht(a), x = !p && !w && !R && dn(a), z = p || w || R || x, j = z ? Wn(a.length, String) : [], ne = j.length;
    for (var V in a)
      Re.call(a, V) && !(z && // Safari 9 has enumerable `arguments.length` in strict mode.
      (V == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      R && (V == "offset" || V == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      x && (V == "buffer" || V == "byteLength" || V == "byteOffset") || // Skip index properties.
      xo(V, ne))) && j.push(V);
    return j;
  }
  function jt(a, u) {
    for (var p = a.length; p--; )
      if (ln(a[p][0], u))
        return p;
    return -1;
  }
  function wr(a, u, p) {
    var w = u(a);
    return Ut(a) ? w : ur(w, p(a));
  }
  function yt(a) {
    return a == null ? a === void 0 ? k : _ : Le && Le in Object(a) ? Ye(a) : sn(a);
  }
  function on(a) {
    return ze(a) && yt(a) == l;
  }
  function an(a, u, p, w, R) {
    return a === u ? !0 : a == null || u == null || !ze(a) && !ze(u) ? a !== a && u !== u : wo(a, u, p, w, an, R);
  }
  function wo(a, u, p, w, R, x) {
    var z = Ut(a), j = Ut(u), ne = z ? c : He(a), V = j ? c : He(u);
    ne = ne == l ? T : ne, V = V == l ? T : V;
    var ye = ne == T, Ee = V == T, le = ne == V;
    if (le && Ht(a)) {
      if (!Ht(u))
        return !1;
      z = !0, ye = !1;
    }
    if (le && !ye)
      return x || (x = new Ue()), z || dn(a) ? Sr(a, u, p, w, R, x) : To(a, u, ne, p, w, R, x);
    if (!(p & o)) {
      var me = ye && Re.call(a, "__wrapped__"), pe = Ee && Re.call(u, "__wrapped__");
      if (me || pe) {
        var nt = me ? a.value() : a, Ze = pe ? u.value() : u;
        return x || (x = new Ue()), R(nt, Ze, p, w, x);
      }
    }
    return le ? (x || (x = new Ue()), Oo(a, u, p, w, R, x)) : !1;
  }
  function So(a) {
    if (!fn(a) || $o(a))
      return !1;
    var u = cn(a) ? Jn : X;
    return u.test(be(a));
  }
  function Eo(a) {
    return ze(a) && _r(a.length) && !!H[yt(a)];
  }
  function _o(a) {
    if (!Ro(a))
      return pt(a);
    var u = [];
    for (var p in Object(a))
      Re.call(a, p) && p != "constructor" && u.push(p);
    return u;
  }
  function Sr(a, u, p, w, R, x) {
    var z = p & o, j = a.length, ne = u.length;
    if (j != ne && !(z && ne > j))
      return !1;
    var V = x.get(a);
    if (V && x.get(u))
      return V == u;
    var ye = -1, Ee = !0, le = p & i ? new Bt() : void 0;
    for (x.set(a, u), x.set(u, a); ++ye < j; ) {
      var me = a[ye], pe = u[ye];
      if (w)
        var nt = z ? w(pe, me, ye, u, a, x) : w(me, pe, ye, a, u, x);
      if (nt !== void 0) {
        if (nt)
          continue;
        Ee = !1;
        break;
      }
      if (le) {
        if (!Jr(u, function(Ze, gt) {
          if (!Ct(le, gt) && (me === Ze || R(me, Ze, p, w, x)))
            return le.push(gt);
        })) {
          Ee = !1;
          break;
        }
      } else if (!(me === pe || R(me, pe, p, w, x))) {
        Ee = !1;
        break;
      }
    }
    return x.delete(a), x.delete(u), Ee;
  }
  function To(a, u, p, w, R, x, z) {
    switch (p) {
      case te:
        if (a.byteLength != u.byteLength || a.byteOffset != u.byteOffset)
          return !1;
        a = a.buffer, u = u.buffer;
      case ae:
        return !(a.byteLength != u.byteLength || !x(new en(a), new en(u)));
      case d:
      case g:
      case v:
        return ln(+a, +u);
      case m:
        return a.name == u.name && a.message == u.message;
      case P:
      case D:
        return a == u + "";
      case y:
        var j = Xr;
      case $:
        var ne = w & o;
        if (j || (j = je), a.size != u.size && !ne)
          return !1;
        var V = z.get(a);
        if (V)
          return V == u;
        w |= i, z.set(a, u);
        var ye = Sr(j(a), j(u), w, R, x, z);
        return z.delete(a), ye;
      case A:
        if (vr)
          return vr.call(a) == vr.call(u);
    }
    return !1;
  }
  function Oo(a, u, p, w, R, x) {
    var z = p & o, j = mt(a), ne = j.length, V = mt(u), ye = V.length;
    if (ne != ye && !z)
      return !1;
    for (var Ee = ne; Ee--; ) {
      var le = j[Ee];
      if (!(z ? le in u : Re.call(u, le)))
        return !1;
    }
    var me = x.get(a);
    if (me && x.get(u))
      return me == u;
    var pe = !0;
    x.set(a, u), x.set(u, a);
    for (var nt = z; ++Ee < ne; ) {
      le = j[Ee];
      var Ze = a[le], gt = u[le];
      if (w)
        var za = z ? w(gt, Ze, le, u, a, x) : w(Ze, gt, le, a, u, x);
      if (!(za === void 0 ? Ze === gt || R(Ze, gt, p, w, x) : za)) {
        pe = !1;
        break;
      }
      nt || (nt = le == "constructor");
    }
    if (pe && !nt) {
      var pn = a.constructor, hn = u.constructor;
      pn != hn && "constructor" in a && "constructor" in u && !(typeof pn == "function" && pn instanceof pn && typeof hn == "function" && hn instanceof hn) && (pe = !1);
    }
    return x.delete(a), x.delete(u), pe;
  }
  function mt(a) {
    return wr(a, Tr, Ao);
  }
  function Ne(a, u) {
    var p = a.__data__;
    return Po(u) ? p[typeof u == "string" ? "string" : "hash"] : p.map;
  }
  function Qe(a, u) {
    var p = cr(a, u);
    return So(p) ? p : void 0;
  }
  function Ye(a) {
    var u = Re.call(a, Le), p = a[Le];
    try {
      a[Le] = void 0;
      var w = !0;
    } catch {
    }
    var R = Zr.call(a);
    return w && (u ? a[Le] = p : delete a[Le]), R;
  }
  var Ao = Dt ? function(a) {
    return a == null ? [] : (a = Object(a), Kr(Dt(a), function(u) {
      return It.call(a, u);
    }));
  } : Co, He = yt;
  (hr && He(new hr(new ArrayBuffer(1))) != te || ht && He(new ht()) != y || yr && He(yr.resolve()) != E || mr && He(new mr()) != $ || gr && He(new gr()) != W) && (He = function(a) {
    var u = yt(a), p = u == T ? a.constructor : void 0, w = p ? be(p) : "";
    if (w)
      switch (w) {
        case tn:
          return te;
        case Xe:
          return y;
        case Xn:
          return E;
        case Qn:
          return $;
        case Yn:
          return W;
      }
    return u;
  });
  function xo(a, u) {
    return u = u ?? s, !!u && (typeof a == "number" || fe.test(a)) && a > -1 && a % 1 == 0 && a < u;
  }
  function Po(a) {
    var u = typeof a;
    return u == "string" || u == "number" || u == "symbol" || u == "boolean" ? a !== "__proto__" : a === null;
  }
  function $o(a) {
    return !!Yr && Yr in a;
  }
  function Ro(a) {
    var u = a && a.constructor, p = typeof u == "function" && u.prototype || ft;
    return a === p;
  }
  function sn(a) {
    return Zr.call(a);
  }
  function be(a) {
    if (a != null) {
      try {
        return fr.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  function ln(a, u) {
    return a === u || a !== a && u !== u;
  }
  var un = on(/* @__PURE__ */ function() {
    return arguments;
  }()) ? on : function(a) {
    return ze(a) && Re.call(a, "callee") && !It.call(a, "callee");
  }, Ut = Array.isArray;
  function Er(a) {
    return a != null && _r(a.length) && !cn(a);
  }
  var Ht = pr || Fo;
  function ko(a, u) {
    return an(a, u);
  }
  function cn(a) {
    if (!fn(a))
      return !1;
    var u = yt(a);
    return u == S || u == h || u == f || u == O;
  }
  function _r(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= s;
  }
  function fn(a) {
    var u = typeof a;
    return a != null && (u == "object" || u == "function");
  }
  function ze(a) {
    return a != null && typeof a == "object";
  }
  var dn = lr ? Gn(lr) : Eo;
  function Tr(a) {
    return Er(a) ? bo(a) : _o(a);
  }
  function Co() {
    return [];
  }
  function Fo() {
    return !1;
  }
  e.exports = ko;
})(Bn, Bn.exports);
Bn.exports;
var Oe = M(null), Sn = M(null), Zo = ji(null), En = M(null), Bi = null;
G({ name: "Inertia", props: { initialPage: { type: Object, required: !0 }, initialComponent: { type: Object, required: !1 }, resolveComponent: { type: Function, required: !1 }, titleCallback: { type: Function, required: !1, default: (e) => e }, onHeadUpdate: { type: Function, required: !1, default: () => () => {
} } }, setup({ initialPage: e, initialComponent: t, resolveComponent: r, titleCallback: n, onHeadUpdate: o }) {
  Oe.value = t ? Va(t) : null, Sn.value = e, En.value = null;
  let i = typeof window > "u";
  return Bi = ty(i, n, o), i || (Oa.init({ initialPage: e, resolveComponent: r, swapComponent: async (s) => {
    Oe.value = Va(s.component), Sn.value = s.page, En.value = s.preserveState ? En.value : Date.now();
  } }), Oa.on("navigate", () => Bi.forceUpdate())), () => {
    if (Oe.value) {
      Oe.value.inheritAttrs = !!Oe.value.inheritAttrs;
      let s = ee(Oe.value, { ...Sn.value.props, key: En.value });
      return Zo.value && (Oe.value.layout = Zo.value, Zo.value = null), Oe.value.layout ? typeof Oe.value.layout == "function" ? Oe.value.layout(ee, s) : (Array.isArray(Oe.value.layout) ? Oe.value.layout : [Oe.value.layout]).concat(s).reverse().reduce((l, c) => (c.inheritAttrs = !!c.inheritAttrs, ee(c, { ...Sn.value.props }, () => l))) : s;
    }
  };
} });
G({ props: { title: { type: String, required: !1 } }, data() {
  return { provider: this.$headManager.createProvider() };
}, beforeUnmount() {
  this.provider.disconnect();
}, methods: { isUnaryTag(e) {
  return ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"].indexOf(e.type) > -1;
}, renderTagStart(e) {
  e.props = e.props || {}, e.props.inertia = e.props["head-key"] !== void 0 ? e.props["head-key"] : "";
  let t = Object.keys(e.props).reduce((r, n) => {
    let o = e.props[n];
    return ["key", "head-key"].includes(n) ? r : o === "" ? r + ` ${n}` : r + ` ${n}="${o}"`;
  }, "");
  return `<${e.type}${t}>`;
}, renderTagChildren(e) {
  return typeof e.children == "string" ? e.children : e.children.reduce((t, r) => t + this.renderTag(r), "");
}, isFunctionNode(e) {
  return typeof e.type == "function";
}, isComponentNode(e) {
  return typeof e.type == "object";
}, isCommentNode(e) {
  return /(comment|cmt)/i.test(e.type.toString());
}, isFragmentNode(e) {
  return /(fragment|fgt|symbol\(\))/i.test(e.type.toString());
}, isTextNode(e) {
  return /(text|txt)/i.test(e.type.toString());
}, renderTag(e) {
  if (this.isTextNode(e)) return e.children;
  if (this.isFragmentNode(e) || this.isCommentNode(e)) return "";
  let t = this.renderTagStart(e);
  return e.children && (t += this.renderTagChildren(e)), this.isUnaryTag(e) || (t += `</${e.type}>`), t;
}, addTitleElement(e) {
  return this.title && !e.find((t) => t.startsWith("<title")) && e.push(`<title inertia>${this.title}</title>`), e;
}, renderNodes(e) {
  return this.addTitleElement(e.flatMap((t) => this.resolveNode(t)).map((t) => this.renderTag(t)).filter((t) => t));
}, resolveNode(e) {
  return this.isFunctionNode(e) ? this.resolveNode(e.type()) : this.isComponentNode(e) ? (console.warn("Using components in the <Head> component is not supported."), []) : this.isTextNode(e) && e.children ? e : this.isFragmentNode(e) && e.children ? e.children.flatMap((t) => this.resolveNode(t)) : this.isCommentNode(e) ? [] : e;
} }, render() {
  this.provider.update(this.renderNodes(this.$slots.default ? this.$slots.default() : []));
} });
var ny = G({ name: "Link", props: { as: { type: String, default: "a" }, data: { type: Object, default: () => ({}) }, href: { type: String, required: !0 }, method: { type: String, default: "get" }, replace: { type: Boolean, default: !1 }, preserveScroll: { type: Boolean, default: !1 }, preserveState: { type: Boolean, default: null }, only: { type: Array, default: () => [] }, except: { type: Array, default: () => [] }, headers: { type: Object, default: () => ({}) }, queryStringArrayFormat: { type: String, default: "brackets" } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    let n = e.as.toLowerCase(), o = e.method.toLowerCase(), [i, s] = ol(o, e.href || "", e.data, e.queryStringArrayFormat);
    return n === "a" && o !== "get" && console.warn(`Creating POST/PUT/PATCH/DELETE <a> links is discouraged as it causes "Open Link in New Tab/Window" accessibility issues.

Please specify a more appropriate element using the "as" attribute. For example:

<Link href="${i}" method="${o}" as="button">...</Link>`), ee(e.as, { ...r, ...n === "a" ? { href: i } : {}, onClick: (l) => {
      ry(l) && (l.preventDefault(), Oa.visit(i, { data: s, method: o, replace: e.replace, preserveScroll: e.preserveScroll, preserveState: e.preserveState ?? o !== "get", only: e.only, except: e.except, headers: e.headers, onCancelToken: r.onCancelToken || (() => ({})), onBefore: r.onBefore || (() => ({})), onStart: r.onStart || (() => ({})), onProgress: r.onProgress || (() => ({})), onFinish: r.onFinish || (() => ({})), onCancel: r.onCancel || (() => ({})), onSuccess: r.onSuccess || (() => ({})), onError: r.onError || (() => ({})) }));
    } }, t);
  };
} }), oy = ny;
const ay = ["type"], iy = ["href"], sy = /* @__PURE__ */ G({
  __name: "TETextButton",
  props: {
    tag: {},
    href: {},
    method: {},
    type: {}
  },
  setup(e) {
    const t = e;
    return (r, n) => t.tag === "button" ? (I(), U("button", {
      key: 0,
      type: t.type,
      class: "font-semibold inline-block text-primary-600 hover:text-primary-500"
    }, [
      Y(r.$slots, "default")
    ], 8, ay)) : t.tag === "a" ? (I(), U("a", {
      key: 1,
      href: t.href,
      class: "font-semibold inline-block text-primary-600 hover:text-primary-500"
    }, [
      Y(r.$slots, "default")
    ], 8, iy)) : (I(), Aa(at(oy), {
      key: 2,
      href: t.href,
      method: t.method ?? "get",
      class: "font-semibold inline-block text-primary-600 hover:text-primary-500"
    }, {
      default: bt(() => [
        Y(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "method"]));
  }
}), cy = {
  install: (e) => {
    e.component("TEButton", dl), e.component("TETable", Fc), e.component("TEBadge", Pl), e.component("TEModal", Nu), e.component("TETextButton", sy), e.component("TETopLabelLayout", xl), e.component("TECard", bl), e.component("TETextInput", Sl), e.component("TENotificationHost", Mu), e.component("TENotification", ua), e.component("TEFlashNotification", Ju), e.component("TEDescriptionList", rc), e.component("TEDescriptionListItem", lc), e.component("TESelect", cc), e.component("TEFormSectionHeader", yc), e.component("TEPagination", Oc);
  }
};
export {
  Pl as TEBadge,
  dl as TEButton,
  bl as TECard,
  rc as TEDescriptionList,
  lc as TEDescriptionListItem,
  Ju as TEFlashNotification,
  yc as TEFormSectionHeader,
  Nu as TEModal,
  ua as TENotification,
  Mu as TENotificationHost,
  Oc as TEPagination,
  cc as TESelect,
  Fc as TETable,
  sy as TETextButton,
  Sl as TETextInput,
  xl as TETopLabelLayout,
  cy as default
};
